<template>
  <f7-page class="page-message-customer-detail" @page:afterin="getAllReport">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại" :back-link-force="true" :back-link-url="`/xu-ly/${region}/${playStyle}`"></f7-nav-left>
      <f7-nav-title sliding>XỬ LÝ {{ title_play_style(region, playStyle) }}</f7-nav-title>
      <f7-nav-right>
        <f7-link @click.prevent="chooseReportDate">{{ this.selected_drawdate | moment('DD/MM/YYYY') }}</f7-link>
      </f7-nav-right>
      <f7-subnavbar>
        <f7-segmented raised>
          <f7-button :tab-link="`#tab-ke-toan-${custId}`" tab-link-active>KẾ TOÁN</f7-button>
          <f7-button :tab-link="`#tab-thong-ke-${custId}`">THỐNG KÊ</f7-button>
          <f7-button :tab-link="`#tab-du-chuan-${custId}`" v-if="selected_customer.type === 1">DƯ CHUẨN
          </f7-button>
          <f7-button style="width: 120px" :tab-link="`#tab-cau-hinh-${custId}`">
            <f7-icon ios="f7:gear_alt"></f7-icon>
          </f7-button>
        </f7-segmented>
      </f7-subnavbar>
    </f7-navbar>
    <f7-tabs>
      <f7-tab :id="`tab-ke-toan-${custId}`" tab-active class="page-content pt-1 pb-icon">
        <div class="fixed-top">
          <f7-list inline-labels class="mb-1 mt-0">
            <f7-list-item :title="this.selected_customer.type === 2 ? `Chủ` : `Khách hàng`" smart-select :smart-select-params="{openIn: 'popup', closeOnSelect: true}">
              <select name="customer" @change="changeCustomer($event.target.value)">
                <optgroup label="Khách">
                  <option v-for="(cust, idx) in _.filter(customers, {type: 1})" :key="idx" :value="cust.id" :selected="selected_customer.id === cust.id">
                    {{ cust.fullname }}
                  </option>
                </optgroup>
                <optgroup label="Chủ">
                  <option v-for="(cust, idx) in _.filter(customers, {type: 2})" :key="idx" :value="cust.id" :selected="selected_customer.id === cust.id">
                    {{ cust.fullname }}
                  </option>
                </optgroup>
              </select>
              <f7-icon slot="media" ios="f7:person" color="crimson"></f7-icon>
            </f7-list-item>
          </f7-list>
          <f7-block class="mt-0">
            <div class="data-table sm bordered card" v-if="!_.isEmpty(report.summary)">
              <table>
                <thead>
                <tr>
                  <th style="width: 33%;" class="text-align-center">XÁC</th>
                  <th style="width: 33%;" class="text-align-center">QUA CÒ</th>
                  <th class="text-align-center">TRÚNG</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="vertical-align-top p-0">
                    <ul class="list-style-none pl-0 mt-0 mb-0">
                      <li v-if="sum_point_1c > 0">
                        <span class="command_type">{{ command_play_style('1C', playStyle) }}:</span>
                        {{ sum_cost_without_rate_1c | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_giainhat > 0">
                        <span class="command_type">{{ command_play_style('GNhat', playStyle) }}:</span>
                        {{ sum_cost_without_rate_giainhat | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_bao > 0">
                        <span class="command_type">{{ command_play_style('2CB', playStyle) }}:</span>
                        {{ sum_cost_without_rate_2c_bao | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dd > 0">
                        <span class="command_type">{{ command_play_style('2CĐ', playStyle) }}:</span>
                        {{ sum_cost_without_rate_2c_dd | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_win_without_win_rate_2c_ui > 0" style="height: 1.4em">&nbsp;</li>
                      <li v-if="sum_point_2c_baylo > 0">
                        <span class="command_type">2CB7:</span>
                        {{ sum_cost_without_rate_2c_baylo | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_tamlo > 0">
                        <span class="command_type">2CB8:</span>
                        {{ sum_cost_without_rate_2c_tamlo | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dat > 0">
                        <span class="command_type">ĐáT:</span>
                        {{ sum_cost_without_rate_2c_dat | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dax > 0">
                        <span class="command_type">ĐáX:</span>
                        {{ sum_cost_without_rate_2c_dax | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dax2 > 0">
                        <span class="command_type">{{ command_play_style('ĐáX2', playStyle) }}:</span>
                        {{ sum_point_2c_dax2 | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dax3 > 0">
                        <span class="command_type">{{ command_play_style('ĐáX3', playStyle) }}:</span>
                        {{ sum_point_2c_dax3 | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dax4 > 0">
                        <span class="command_type">{{ command_play_style('ĐáX4', playStyle) }}:</span>
                        {{ sum_point_2c_dax4 | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_3c_bao > 0">
                        <span class="command_type">{{ command_play_style('3CB', playStyle) }}:</span>
                        {{ sum_cost_without_rate_3c_bao | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_3c_bay > 0">
                        <span class="command_type">3CB7:</span>
                        {{ sum_cost_without_rate_3c_bay | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_3c_xc > 0">
                        <span class="command_type">{{ command_play_style('3CXC', playStyle) }}:</span>
                        {{ sum_cost_without_rate_3c_xc | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_4c > 0">
                        <span class="command_type">4C:</span>
                        {{ sum_cost_without_rate_4c | numeral('0,0[.]0') }}
                      </li>
                    </ul>
                  </td>
                  <td class="vertical-align-top p-0">
                    <ul class="list-style-none pl-0 mt-0 mb-0">
                      <li v-if="sum_point_1c > 0">
                        <span class="command_type">{{ command_play_style('1C', playStyle) }}:</span>
                        {{ sum_cost_1c | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_giainhat > 0">
                        <span class="command_type">{{ command_play_style('GNhat', playStyle) }}:</span>
                        {{ sum_cost_giainhat | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_bao > 0">
                        <span class="command_type">{{ command_play_style('2CB', playStyle) }}:</span>
                        {{ sum_cost_2c_bao | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dd > 0">
                        <span class="command_type">{{ command_play_style('2CĐ', playStyle) }}:</span>
                        {{ sum_cost_2c_dd | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_win_without_win_rate_2c_ui > 0" style="height: 1.4em">&nbsp;</li>
                      <li v-if="sum_point_2c_baylo > 0">
                        <span class="command_type">2CB7:</span>
                        {{ sum_cost_2c_baylo | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_tamlo > 0">
                        <span class="command_type">2CB8:</span>
                        {{ sum_cost_2c_tamlo | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dat > 0">
                        <span class="command_type">ĐáT:</span>
                        {{ sum_cost_2c_dat | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dax > 0">
                        <span class="command_type">ĐáX:</span>
                        {{ sum_cost_2c_dax | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dax2 > 0">
                        <span class="command_type">{{ command_play_style('ĐáX2', playStyle) }}:</span>
                        {{ sum_cost_2c_dax2 | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dax3 > 0">
                        <span class="command_type">{{ command_play_style('ĐáX3', playStyle) }}:</span>
                        {{ sum_cost_2c_dax3 | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_2c_dax4 > 0">
                        <span class="command_type">{{ command_play_style('ĐáX4', playStyle) }}:</span>
                        {{ sum_cost_2c_dax4 | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_3c_bao > 0">
                        <span class="command_type">{{ command_play_style('3CB', playStyle) }}:</span>
                        {{ sum_cost_3c_bao | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_3c_bay > 0">
                        <span class="command_type">3CB7:</span>
                        {{ sum_cost_3c_bay | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_3c_xc > 0">
                        <span class="command_type">{{ command_play_style('3CXC', playStyle) }}:</span>
                        {{ sum_cost_3c_xc | numeral('0,0[.]0') }}
                      </li>
                      <li v-if="sum_point_4c > 0">
                        <span class="command_type">4C:</span>
                        {{ sum_cost_4c | numeral('0,0[.]0') }}
                      </li>
                    </ul>
                  </td>
                  <td class="vertical-align-top p-0">
                    <ul class="list-style-none pl-0 mt-0 mb-0">
                      <li v-if="sum_point_1c > 0">
                        <span class="command_type">{{ command_play_style('1C', playStyle) }}:</span>
                        {{ sum_win_without_win_rate_1c | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_giainhat > 0">
                        <span class="command_type">{{ command_play_style('GNhat', playStyle) }}:</span>
                        {{ sum_win_without_win_rate_giainhat | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_2c_bao > 0">
                        <span class="command_type">{{ command_play_style('2CB', playStyle) }}:</span>
                        {{ sum_win_without_win_rate_2c_bao | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_2c_dd > 0">
                        <span class="command_type">{{ command_play_style('2CĐ', playStyle) }}:</span>
                        {{ sum_win_without_win_rate_2c_dd | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_win_without_win_rate_2c_ui > 0">
                        <span class="command_type">An Ủi:</span>
                        {{ sum_win_without_win_rate_2c_ui | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_2c_baylo > 0">
                        <span class="command_type">2CB7:</span>
                        {{ sum_win_without_win_rate_2c_baylo | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_2c_tamlo > 0">
                        <span class="command_type">2CB8:</span>
                        {{ sum_win_without_win_rate_2c_tamlo | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_2c_dat > 0">
                        <span class="command_type">ĐáT:</span>
                        {{ sum_win_without_win_rate_2c_dat | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_2c_dax > 0">
                        <span class="command_type">ĐáX:</span>
                        {{ sum_win_without_win_rate_2c_dax | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_2c_dax2 > 0">
                        <span class="command_type">{{ command_play_style('ĐáX2', playStyle) }}:</span>
                        {{ sum_win_without_win_rate_2c_dax2 | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_2c_dax3 > 0">
                        <span class="command_type">{{ command_play_style('ĐáX3', playStyle) }}:</span>
                        {{ sum_win_without_win_rate_2c_dax3 | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_2c_dax4 > 0">
                        <span class="command_type">{{ command_play_style('ĐáX4', playStyle) }}:</span>
                        {{ sum_win_without_win_rate_2c_dax4 | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_3c_bao > 0">
                        <span class="command_type">{{ command_play_style('3CB', playStyle) }}:</span>
                        {{ sum_win_without_win_rate_3c_bao | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_3c_bay > 0">
                        <span class="command_type">3CB7:</span>
                        {{ sum_win_without_win_rate_3c_bay | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_3c_xc > 0">
                        <span class="command_type">{{ command_play_style('3CXC', playStyle) }}:</span>
                        {{ sum_win_without_win_rate_3c_xc | numeral('0,0[.]00') }}
                      </li>
                      <li v-if="sum_point_4c > 0">
                        <span class="command_type">4C:</span>
                        {{ sum_win_without_win_rate_4c | numeral('0,0[.]00') }}
                      </li>
                    </ul>
                  </td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                  <th class="text-align-center">{{ sum_cost_without_rate | numeral('0,0[.]00') }}</th>
                  <th class="text-align-center">{{ sum_cost | numeral('0,0[.]00') }}</th>
                  <th class="text-align-center">{{ sum_win | numeral('0,0[.]00') }}</th>
                </tr>
                <tr>
                  <th colspan="3" :class="{'text-color-forestgreen': sum_total >= 0, 'text-color-crimson': sum_total < 0}">
                    <span>{{ sum_total >= 0 ? 'Thu' : 'Bù' }}</span>
                    <span>: {{ sum_total | numeral('0,0[.]0') }} x {{ total_percent }}% </span>
                    <span>= {{ sum_result | numeral('0,0[.]0') }} </span>
                    <span v-if="line_percent > 0" class="text-color-blue">
                  - ({{ line_percent }}% hồi)
                </span>
                    <span v-if="line_percent > 0" class="text-color-blue">
                  = {{ sum_final | numeral('0,0[.]0') }}
                </span>
                    <p class="text-align-right">
                    <f7-link external :href="`${save_report_image}`" :target="is_in_app() ? '_self' : '_blank'">
                      <f7-icon size="16" f7="camera"></f7-icon>
                    </f7-link>
                    <f7-link class="margin-left-half" @click.prevent="copyReport">
                      <f7-icon size="16" f7="doc_on_doc"></f7-icon>
                    </f7-link>
                  </p>
                  </th>
                </tr>
                </tfoot>
              </table>
            </div>
          </f7-block>
        </div>
        <template v-if="!_.isEmpty(report.list_messages)">
          <f7-row class="after-fixed-top">
            <f7-col>
              <f7-block-title class="mt-0 mb-0">CHI TIẾT</f7-block-title>
            </f7-col>
            <f7-col>
              <f7-block-title class="mt-0 mb-0 text-align-right text-color-crimson" v-if="msg_selecting === false">
                <f7-link @click.prevent="msg_selecting = true, checked_items = []">
                  <f7-icon size="18px" ios="f7:checkmark_square"></f7-icon>
                  Chọn
                </f7-link>
              </f7-block-title>
              <f7-block-title class="mt-0 mb-0 text-align-right text-color-crimson" v-else>
                <f7-link @click.prevent="toggleAllCheckbox">
                  <f7-icon size="18px" ios="f7:checkmark_rectangle" class="mr-05"></f7-icon>
                  Tất cả
                </f7-link>
                &nbsp;/&nbsp;
                <f7-link @click.prevent="msg_selecting = false">
                  Bỏ chọn
                </f7-link>
              </f7-block-title>
            </f7-col>
          </f7-row>
          <message-summary v-for="(item, idx) in report.list_messages" :key="idx" :stt="idx + 1" :message="item" :region="region" :play-style="playStyle" :cust-id="custId" :customer="selected_customer" :selecting="msg_selecting" :checked-items="checked_items" @toggle-checkbox="toggleCheckbox"></message-summary>
        </template>
      </f7-tab>
      <f7-tab :id="`tab-thong-ke-${custId}`" class="page-content pt-0 pb-icon">
        <template v-if="user_info.server_region === 'hanoi'">
          <f7-block class="mt-1 mb-2" inset>
            <f7-segmented strong tag="p" v-if="region !== 'mb'">
              <f7-button v-for="(opt, idx) in filter_channel_options[region][full_datename.toLowerCase()]" :key="idx" :active="filters.channel === idx" @click.prevent="chooseFilter('channel', idx)">
                {{ opt.toUpperCase() }}
              </f7-button>
            </f7-segmented>
            <f7-segmented strong v-if="playStyle === 'mb_hanoi'" tag="p">
              <f7-button :active="filters.command === '2c'" @click.prevent="chooseFilter('command', '2c')">
                Lô
              </f7-button>
              <f7-button :active="filters.command === 'de,duoi,duoi_2'" @click.prevent="chooseFilter('command', 'de,duoi,duoi_2')">
                Đề
              </f7-button>
              <f7-button :active="filters.command === 'de_tonghop'" @click.prevent="chooseFilter('command', 'de_tonghop')">
                Đề t.hợp
              </f7-button>
              <f7-button :active="filters.command === 'daunhat,giainhat'" @click.prevent="chooseFilter('command', 'daunhat,giainhat')">
                GNhất
              </f7-button>
              <f7-button :active="filters.command === '3c'" @click.prevent="chooseFilter('command', '3c')">
                3Càng
              </f7-button>
              <f7-button :active="filters.command === 'dx,dx_2,dx_3,dx_4'" @click.prevent="chooseFilter('command', 'dx,dx_2,dx_3,dx_4')">
                Xiên
              </f7-button>
            </f7-segmented>
          </f7-block>
          <f7-block strong inset class="mt-0">
            <p>Tổng số dòng : {{ parsed_messages.length }}</p>
            <f7-row class="border-bottom-thin-solid font-bold pb-1">
              <f7-col @click.prevent="sortReport">
                <f7-button fill raised color="orange" style="margin-top: -5px; overflow: inherit; min-width: 60px; padding: 0 2px;">
                  C.PHÁP
                </f7-button>
              </f7-col>
              <f7-col><span @click.prevent="message_sort = !message_sort">SỐ</span></f7-col>
              <f7-col class="text-align-right">ĐIỂM</f7-col>
              <f7-col class="text-align-right">DƯ</f7-col>
            </f7-row>
            <virtual-list style="height: 400px; overflow-y: auto;" :data-key="'uid'" :data-sources="parsed_messages" :data-component="itemMbNganComponent"/>
          </f7-block>
        </template>
        <template v-else>
          <f7-block class="mt-1 mb-2" inset>
            <f7-segmented strong tag="p" v-if="region !== 'mb'">
              <f7-button v-for="(opt, idx) in filter_channel_options[region][full_datename.toLowerCase()]" :key="idx" :active="filters.channel === idx" @click.prevent="chooseFilter('channel', idx)">
                {{ opt.toUpperCase() }}
              </f7-button>
            </f7-segmented>
            <f7-segmented strong v-if="playStyle === 'mb_ngan'" tag="p">
              <f7-button :active="filters.command === 'de'" @click.prevent="chooseFilter('command', 'de')">
                Đề
              </f7-button>
              <f7-button :active="filters.command === 'de_tonghop'" @click.prevent="chooseFilter('command', 'de_tonghop')">
                Đề tổng hợp
              </f7-button>
              <f7-button :active="filters.command === '2c'" @click.prevent="chooseFilter('command', '2c')">
                Lô
              </f7-button>
              <f7-button :active="filters.command === '3c'" @click.prevent="chooseFilter('command', '3c')">
                3Càng
              </f7-button>
              <f7-button :active="filters.command === 'dx,dx_2,dx_3,dx_4'" @click.prevent="chooseFilter('command', 'dx,dx_2,dx_3,dx_4')">
                Xiên
              </f7-button>
            </f7-segmented>
            <f7-segmented strong v-else tag="p">
              <f7-button :active="filters.command === '2c'" @click.prevent="chooseFilter('command', '2c')">
                2C
              </f7-button>
              <f7-button :active="filters.command === '3c'" @click.prevent="chooseFilter('command', '3c')">
                3C
              </f7-button>
              <f7-button :active="filters.command === '4c'" @click.prevent="chooseFilter('command', '4c')">
                4C
              </f7-button>
              <f7-button :active="filters.command === 'dat'" @click.prevent="chooseFilter('command', 'dat')">
                ĐáT
              </f7-button>
              <f7-button :active="filters.command === 'dx,dx_2,dx_3,dx_4'" @click.prevent="chooseFilter('command', 'dx,dx_2,dx_3,dx_4')">
                ĐáX
              </f7-button>
            </f7-segmented>
          </f7-block>
          <f7-block strong inset class="mt-0">
            <template v-if="playStyle !== 'mb_ngan'">
              <p>Tổng số dòng : {{ parsed_messages.length }}</p>
              <f7-row class="border-bottom-thin-solid font-bold pb-1">
                <f7-col>
                  <span @click.prevent="message_sort = !message_sort">SỐ</span>
                </f7-col>
                <f7-col>ĐÀI</f7-col>
                <f7-col @click.prevent="sortReport">
                  <f7-button fill raised color="orange" class="btn-sorting">
                    C.PHÁP
                  </f7-button>
                </f7-col>
                <f7-col class="text-align-right">ĐIỂM</f7-col>
                <f7-col class="text-align-right">DƯ</f7-col>
              </f7-row>
              <virtual-list style="height: 400px; overflow-y: auto;" :data-key="'uid'" :data-sources="parsed_messages" :data-component="itemComponent"/>
            </template>
            <template v-else>
              <p>Tổng số dòng : {{ parsed_messages.length }}</p>
              <f7-row class="border-bottom-thin-solid font-bold pb-1">
                <f7-col @click.prevent="sortReport">
                  <f7-button fill raised color="orange" style="margin-top: -5px; overflow: inherit; min-width: 60px; padding-left: 2px; padding-right: 2px;">
                    C.PHÁP
                  </f7-button>
                </f7-col>
                <f7-col>
                  <span @click.prevent="message_sort = !message_sort">SỐ</span>
                </f7-col>
                <f7-col class="text-align-right">ĐIỂM</f7-col>
                <f7-col class="text-align-right">DƯ</f7-col>
              </f7-row>
              <virtual-list style="height: 400px; overflow-y: auto;" :data-key="'uid'" :data-sources="parsed_messages" :data-component="itemMbNganComponent"/>
            </template>
          </f7-block>
        </template>
      </f7-tab>
      <f7-tab :id="`tab-du-chuan-${custId}`" class="page-content pt-0 pb-icon">
        <template v-if="warning_messages.length > 0">
          <f7-block inset>
            <div class="data-table sm bordered card" v-for="(item, idx) in warning_messages" :key="idx">
              <table>
                <tbody>
                <tr @click.prevent="goToEditMessage(item)">
                  <td>
                    <strong>{{ (warning_messages.length - idx) }}.</strong> {{ item.content }}
                  </td>
                </tr>
                <tr v-if="item.combined !== ''">
                  <td class="text-color-red pt-05 pb-05">
                    <f7-row>
                      <f7-col width="90">
                        {{ item.combined }}
                      </f7-col>
                      <f7-col width="10">
                        <f7-button color="orange" fill round @click.prevent="$copyText(item.combined.trim()), showToastBottom('Đã copied')">
                          <f7-icon ios="f7:doc_on_doc" size="20"></f7-icon>
                        </f7-button>
                      </f7-col>
                    </f7-row>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </f7-block>
        </template>
        <f7-block inset strong v-else>
          Chưa có tin nhắn nào!
        </f7-block>
      </f7-tab>
      <f7-tab :id="`tab-cau-hinh-${custId}`" class="page-content pt-0 pb-icon">
        <ConfigOverPointNgheAn v-if="playStyle.indexOf('_ngan') >= 0" :region="region" :play-style="playStyle" :cust-id="custId" v-on:updatedConfig="updatedConfig" ref="configOverPoint"></ConfigOverPointNgheAn>
        <ConfigOverPointHanoi v-if="playStyle.indexOf('_hanoi') >= 0" :region="region" :play-style="playStyle" :cust-id="custId" v-on:updatedConfig="updatedConfig" ref="configOverPoint"></ConfigOverPointHanoi>
        <ConfigOverPointBmt v-else-if="playStyle.indexOf('_buonme') >= 0" :region="region" :play-style="playStyle" :cust-id="custId" v-on:updatedConfig="updatedConfig" ></ConfigOverPointBmt>
        <ConfigOverPointDefault v-else :region="region" :enable-block-number="false" :play-style="playStyle" :cust-id="custId" v-on:updatedConfig="updatedConfig" ref="configOverPoint"></ConfigOverPointDefault>
      </f7-tab>
    </f7-tabs>
    <f7-fab position="right-bottom" slot="fixed" color="red" @click.prevent="goToCreate('')" v-if="msg_selecting === false">
      <f7-icon ios="f7:plus"></f7-icon>
    </f7-fab>
    <f7-fab position="right-bottom" class="button-2" slot="fixed" color="orange" @click.prevent="openPopupFriend" v-if="msg_selecting === false">
      <f7-icon ios="f7:bubble_left_bubble_right"></f7-icon>
    </f7-fab>
    <f7-fab position="right-bottom" slot="fixed" color="orange" @click.prevent="copyToClipboard" v-if="msg_selecting === true">
      <f7-icon ios="f7:doc_on_doc"></f7-icon>
    </f7-fab>
    <f7-fab position="right-bottom" class="button-2" slot="fixed" color="red" @click.prevent="removeSelectedMessage" v-if="msg_selecting === true">
      <f7-icon ios="f7:trash"></f7-icon>
    </f7-fab>
    <f7-popup :opened="popup_friends" @popup:closed="popup_friends = false" :tablet-fullscreen="true">
      <f7-page>
        <f7-navbar title="HỘP THƯ">
          <f7-nav-right>
            <f7-link popup-close>Đóng</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block inset class="mt-1 mb-0">
          <f7-segmented raised>
            <f7-button :active="friend_tab_active === 'friend_list'" @click.prevent="friend_tab_active = 'friend_list'">
              BẠN BÈ
            </f7-button>
            <f7-button :active="friend_tab_active === 'bot_list'" @click.prevent="friend_tab_active = 'bot_list'">
              CHATBOT
            </f7-button>
          </f7-segmented>
        </f7-block>
        <template v-if="friend_tab_active === 'friend_list'">
          <f7-list class="mb-4" media-list>
            <f7-list-item v-for="(item, idx) in _.orderBy(friends, ['last_message_created_at'], ['desc'])" :key="idx" :title="item.username" :text="item.last_message | strip_tags" :after="item.last_message_created_at | moment('DD/MM HH:mm')" link @click="chooseFriend(item)">
              <img src="../../assets/images/no-avatar.png" slot="media" class="friend-avatar">
            </f7-list-item>
          </f7-list>
        </template>
        <template v-else-if="friend_tab_active === 'bot_list'">
          <template v-if="!_.isEmpty(filteredBots)">
            <f7-list class="mb-4" media-list>
              <f7-list-item v-for="(item, idx) in filteredBots" :key="idx"
                            link
                            :title="item.fullname"
                            :subtitle="subTitle(item)"
                            @click="chooseChatbot(item)">
                <img v-if="item.bot_type.indexOf('telegram') >= 0" src="../../assets/images/telegram.png" slot="media" class="friend-avatar">
                <img v-else src="../../assets/images/no-avatar.png" slot="media" class="friend-avatar">
              </f7-list-item>
            </f7-list>
          </template>
          <f7-block strong v-else class="text-align-center">
            Chưa có chatbot nào!
          </f7-block>
        </template>
      </f7-page>
    </f7-popup>
    <f7-popup :opened="popup_chat" @popup:closed="popup_chat = false, selected_messages = []" :tablet-fullscreen="true">
      <f7-page>
        <f7-navbar>
          <f7-nav-left>
            <f7-link popup-close>Đóng</f7-link>
          </f7-nav-left>
          <f7-nav-title v-if="friend_tab_active === 'friend_list'">{{ selected_friend.username }}</f7-nav-title>
          <f7-nav-title v-else-if="friend_tab_active === 'bot_list'">{{ selected_chatbot.fullname }}</f7-nav-title>
          <f7-nav-title v-else>Chat</f7-nav-title>
          <f7-nav-right>
            <f7-link @click.prevent="submitChooseMessage">Chọn</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-messages ref="messages" :scroll-messages="false">
          <f7-messages-title v-if="messagesFormatted.length === 0"><b>Chưa có dữ liệu!</b></f7-messages-title>
          <template v-for="(message, index) in messagesFormatted">
            <f7-messages-title :key="index" v-if="message.isTitle"><b>{{ message.text }}</b></f7-messages-title>
            <f7-message
              v-else
              :key="index"
              :type="message.type"
              :name="message.name"
              :footer="message.footer"
              :text-footer="message.created_at"
              :first="isFirstMessage(message, index)"
              :last="isLastMessage()"
              :tail="isTailMessage(message, index)"
            >
              <span slot="text" v-if="message.text" v-html="(message.status === -1) ? `<s>${message.text}</s>` : message.text"></span>
              <template slot="avatar">
                <f7-checkbox :checked="_.findIndex(selected_messages, {id: message.id}) >= 0" @change="chooseMessage(message)"></f7-checkbox>
              </template>
            </f7-message>
          </template>
        </f7-messages>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<script>
// import moment from "moment";
import Big from 'big.js';
import {mapState} from 'vuex';
import MessageSummary from "@/components/MessageSummary";
import ItemRowReportOverCustomer from "@/components/ItemRowReportOverCustomer";
import ItemRowReportOverCustomerMbNgan from "@/components/ItemRowReportOverCustomerMbNgan";
import numeral from 'numeral';

import ConfigOverPointDefault from "./components/ConfigOverPointDefault";
import ConfigOverPointNgheAn from "./components/ConfigOverPointNgheAn";
import ConfigOverPointBmt from "./components/ConfigOverPointBmt";
import ConfigOverPointHanoi from "./components/ConfigOverPointHanoi";
import moment from "moment-timezone";

export default {
  components:{
    MessageSummary,
    ConfigOverPointDefault,
    ConfigOverPointNgheAn,
    ConfigOverPointBmt,
    ConfigOverPointHanoi
  },
  props     :{
    region   :String,
    playStyle:String,
    custId   :String
  },
  data(){
    return {
      report                :{},
      regions               :{
        mn:'Miền Nam',
        mb:'Miền Bắc',
        mt:'Miền Trung'
      },
      myCalendar            :null,
      msg_selecting         :false,
      checked_items         :[],
      filter_channel_options:{
        mb:{
          monday:{
            mb:'mb'
          },
          tuesday:{
            mb:'mb'
          },
          wednesday:{
            mb:'mb'
          },
          thursday:{
            mb:'mb'
          },
          friday:{
            mb:'mb'
          },
          saturday:{
            mb:'mb'
          },
          sunday:{
            mb:'mb'
          },
        },
        mn:{
          monday:{
            dc :'tp',
            dp :'dt',
            dp2:'cm'
          },
          tuesday:{
            dc :'bt',
            dp :'vt',
            dp2:'bl'
          },
          wednesday:{
            dc :'dn',
            dp :'ct',
            dp2:'st'
          },
          thursday:{
            dc :'tn',
            dp :'ag',
            dp2:'bt'
          },
          friday:{
            dc :'vl',
            dp :'bd',
            dp2:'tv'
          },
          saturday:{
            dc :'tp',
            dp :'la',
            dp2:'bp',
            dp3:'hg'
          },
          sunday:{
            dc :'tg',
            dp :'kg',
            dp2:'dl'
          },
        },
        mt:{
          monday:{
            dc:'py',
            dp:'th'
          },
          tuesday:{
            dc:'dl',
            dp:'qn'
          },
          wednesday:{
            dc:'dn',
            dp:'kh'
          },
          thursday:{
            dc :'bd',
            dp :'qt',
            dp2:'qb'
          },
          friday:{
            dc:'gl',
            dp:'nt'
          },
          saturday:{
            dc :'dn',
            dp :'qn',
            dp2:'dno'
          },
          sunday:{
            dc :'kt',
            dp :'kh',
            dp2:'tth'
          },
        }
      },
      filters               :{
        channel:'dc',
        command:'2c'
      },
      commands              :[],
      report_data           :{
        over_points:[]
      },
      itemComponent         :ItemRowReportOverCustomer,
      itemMbNganComponent   :ItemRowReportOverCustomerMbNgan,
      warning_messages      :[],
      popup_friends         :false,
      popup_chat            :false,
      selected_friend       :{},
      messagesData          :[],
      selected_messages     :[],
      friend_tab_active: 'friend_list',
      bots: [],
      selected_chatbot      :{},
      chatbot_messages: [],
      message_sort: 0,
    }
  },
  computed:{
    ...mapState(['selected_customer', 'selected_drawdate', 'user_info', 'customers', 'friends']),
    messagesFormatted(){
      let messages = [];
      let current_date = '';

      if(this.friend_tab_active === 'friend_list'){
        this._.each(this.messagesData, (item) => {
          if (this.$moment(item.created_at).format('DD/MM/YYYY') !== current_date) {
            messages.push({
              isTitle: true,
              text: this.$moment(item.created_at).format('DD/MM/YYYY')
            });
            current_date = this.$moment(item.created_at).format('DD/MM/YYYY');
          }

          messages.push({
            id: item.chat_message_id,
            isTitle: false,
            type: (item.username === this.user_info.username) ? 'sent' : 'received',
            text: item.message,
            name: item.username,
            image: item.file_url,
            footer: item.footer,
            created_at: this.$moment(item.created_at).format('HH:mm'),
            status: item.status
          });
        });
      } else if (this.friend_tab_active === 'bot_list'){
        this._.each(this.messagesData, (item) => {
          if (this.$moment(item.created_at).format('DD/MM/YYYY') !== current_date) {
            messages.push({
              isTitle: true,
              text: this.$moment(item.created_at).format('DD/MM/YYYY')
            });
            current_date = this.$moment(item.created_at).format('DD/MM/YYYY');
          }

          messages.push({
            id: item.id,
            isTitle: false,
            type: 'received',
            text: item.content_original,
            name: 'Chatbot',
            image: null,
            footer: null,
            created_at: this.$moment(item.created_at).format('HH:mm'),
            status: item.status
          });
        });
      }

      return messages;
    },
    filteredBots() {
      return this._.filter(this.bots, {bot_type: 'telegram_free_text'});
    },
    short_datename(){
      return this.$moment(this.selected_drawdate).format('dd')
    },
    full_datename(){
      return this.$moment(this.selected_drawdate).format('dddd')
    },
    first_channel(){
      let real_region = this.region;
      if(this.playStyle === 'mb_ngan'){
        real_region = 'mb_ngan';
      }
      return Object.keys(this.over_point_config.general_overpoint[real_region][this.full_datename.toLowerCase()])[0];
    },
    dc(){
      return this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dc;
    },
    dp(){
      return this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp;
    },
    dp2(){
      return (this._.isUndefined(this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp2)) ? '' : this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp2;
    },
    dp3(){
      return (this._.isUndefined(this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp3)) ? '' : this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp3;
    },
    parsed_messages(){
      if(this._.isEmpty(this.report_data.over_points)){
        return [];
      }

      let msgs = [];
      this._.each(this.report_data.over_points, (msg, msg_idx) => {
        msgs.push({
          uid           :msg_idx,
          number        :msg.number,
          channel       :msg.channel,
          command       :msg.command_display,
          point         :msg.point,
          over_point    :msg.over_point,
          executed_point:msg.executed_point,
        });
      });

      if(this.message_sort){
        return this._.orderBy(msgs, ['number'], ['asc']);
      } else {
        return this._.orderBy(msgs, [(item) => {
          return this.commands.indexOf(item.command);
        }, 'point'], ['asc', 'desc']);
      }
    },
    over_point_config(){
      return {
        number_overpoint :{},
        general_overpoint:this.selected_customer.over_point_config
      };
    },
    sum_point_1c(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary) && !this._.isUndefined(this.report.summary.mb_ngan)){
        sum += this.report.summary.mb_ngan['1c'].point.ngang;
      }
      return sum;
    },
    sum_point_giainhat() {
      let sum = 0;
      if (!this._.isEmpty(this.report.summary) && !this._.isUndefined(this.report.summary.mb_hanoi)) {
        sum += this.report.summary.mb_hanoi['2c'].point.giainhat;
        sum += this.report.summary.mb_hanoi['2c'].point.daunhat;
      }
      return sum;
    },
    sum_point_2c_bao(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].point.baolo;
        sum += this.report.summary.mb['2c'].point.baolo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].point.baolo;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].point.baolo;
        }
        sum += this.report.summary.mt['2c'].point.baolo;
        sum += this.report.summary.mn_buonme['2c'].point.baolo;
        sum += this.report.summary.mb_buonme['2c'].point.baolo;
        sum += this.report.summary.mt_buonme['2c'].point.baolo;
      }
      return sum;
    },
    sum_point_2c_dd(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].point.dau;
        sum += this.report.summary.mb['2c'].point.dau;
        sum += this.report.summary.mt['2c'].point.dau;

        sum += this.report.summary.mn['2c'].point.duoi;
        sum += this.report.summary.mb['2c'].point.duoi;
        sum += this.report.summary.mt['2c'].point.duoi;

        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].point.dau;
          sum += this.report.summary.mb_ngan['2c'].point.duoi;
        }

        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].point.dau;
          sum += this.report.summary.mb_hanoi['2c'].point.duoi;
        }

          sum += this.report.summary.mn_buonme['2c'].point.dau;
          sum += this.report.summary.mb_buonme['2c'].point.dau;
          sum += this.report.summary.mt_buonme['2c'].point.dau;
          sum += this.report.summary.mn_buonme['2c'].point.duoi;
          sum += this.report.summary.mb_buonme['2c'].point.duoi;
          sum += this.report.summary.mt_buonme['2c'].point.duoi;
          sum += this.report.summary.mn_buonme['2c'].point.ke;
          sum += this.report.summary.mb_buonme['2c'].point.ke;
          sum += this.report.summary.mt_buonme['2c'].point.ke;
      }
      return sum;
    },
    sum_point_2c_dat(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].point.dat;
        sum += this.report.summary.mb['2c'].point.dat;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].point.dat;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].point.dat;
        }
        sum += this.report.summary.mt['2c'].point.dat;

          sum += this.report.summary.mn_buonme['2c'].point.dat;
          sum += this.report.summary.mb_buonme['2c'].point.dat;
          sum += this.report.summary.mt_buonme['2c'].point.dat;
      }
      return sum;
    },
    sum_point_2c_dax(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].point.dx;
        sum += this.report.summary.mb['2c'].point.dx;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].point.dx;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].point.dx;
        }
        sum += this.report.summary.mt['2c'].point.dx;

          sum += this.report.summary.mn_buonme['2c'].point.dx;
          sum += this.report.summary.mb_buonme['2c'].point.dx;
          sum += this.report.summary.mt_buonme['2c'].point.dx;
      }
      return sum;
    },
    sum_point_2c_dax2(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].point.dx_2;
        sum += this.report.summary.mb['2c'].point.dx_2;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].point.dx_2;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].point.dx_2;
        }
        sum += this.report.summary.mt['2c'].point.dx_2;

          sum += this.report.summary.mn_buonme['2c'].point.dx_2;
          sum += this.report.summary.mb_buonme['2c'].point.dx_2;
          sum += this.report.summary.mt_buonme['2c'].point.dx_2;
      }
      return sum;
    },
    sum_point_2c_dax3(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].point.dx_3;
        sum += this.report.summary.mb['2c'].point.dx_3;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].point.dx_3;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].point.dx_3;
        }
        sum += this.report.summary.mt['2c'].point.dx_3;

          sum += this.report.summary.mn_buonme['2c'].point.dx_3;
          sum += this.report.summary.mb_buonme['2c'].point.dx_3;
          sum += this.report.summary.mt_buonme['2c'].point.dx_3;
      }
      return sum;
    },
    sum_point_2c_dax4(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].point.dx_4;
        sum += this.report.summary.mb['2c'].point.dx_4;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].point.dx_4;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].point.dx_4;
        }
        sum += this.report.summary.mt['2c'].point.dx_4;

          sum += this.report.summary.mn_buonme['2c'].point.dx_4;
          sum += this.report.summary.mb_buonme['2c'].point.dx_4;
          sum += this.report.summary.mt_buonme['2c'].point.dx_4;
      }
      return sum;
    },
    sum_point_2c_baylo(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].point.baylo;
        sum += this.report.summary.mb['2c'].point.baylo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].point.baylo;
        }
        sum += this.report.summary.mt['2c'].point.baylo;

          sum += this.report.summary.mn_buonme['2c'].point.baylo;
          sum += this.report.summary.mb_buonme['2c'].point.baylo;
          sum += this.report.summary.mt_buonme['2c'].point.baylo;
      }
      return sum;
    },
    sum_point_2c_tamlo(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].point.tamlo;
        sum += this.report.summary.mb['2c'].point.tamlo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].point.tamlo;
        }
        sum += this.report.summary.mt['2c'].point.tamlo;

          sum += this.report.summary.mn_buonme['2c'].point.tamlo;
          sum += this.report.summary.mb_buonme['2c'].point.tamlo;
          sum += this.report.summary.mt_buonme['2c'].point.tamlo;
      }
      return sum;
    },
    sum_point_3c_bao(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].point.baolo;
        sum += this.report.summary.mb['3c'].point.baolo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].point.baolo;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['3c'].point.baolo;
        }
        sum += this.report.summary.mt['3c'].point.baolo;

          sum += this.report.summary.mn_buonme['3c'].point.baolo;
          sum += this.report.summary.mb_buonme['3c'].point.baolo;
          sum += this.report.summary.mt_buonme['3c'].point.baolo;
      }
      return sum;
    },
    sum_point_3c_bay(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].point.baylo;
        sum += this.report.summary.mb['3c'].point.baylo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].point.baylo;
        }
        sum += this.report.summary.mt['3c'].point.baylo;

          sum += this.report.summary.mn_buonme['3c'].point.baylo;
          sum += this.report.summary.mb_buonme['3c'].point.baylo;
          sum += this.report.summary.mt_buonme['3c'].point.baylo;
      }
      return sum;
    },
    sum_point_3c_xc(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].point.dau;
        sum += this.report.summary.mn['3c'].point.duoi;
        sum += this.report.summary.mb['3c'].point.dau;
        sum += this.report.summary.mb['3c'].point.duoi;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].point.dau;
          sum += this.report.summary.mb_ngan['3c'].point.duoi;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['3c'].point.dau;
          sum += this.report.summary.mb_hanoi['3c'].point.duoi;
        }
        sum += this.report.summary.mt['3c'].point.dau;
        sum += this.report.summary.mt['3c'].point.duoi;

          sum += this.report.summary.mn_buonme['3c'].point.dau;
          sum += this.report.summary.mn_buonme['3c'].point.duoi;
          sum += this.report.summary.mn_buonme['3c'].point.ke;
          sum += this.report.summary.mb_buonme['3c'].point.dau;
          sum += this.report.summary.mb_buonme['3c'].point.duoi;
          sum += this.report.summary.mb_buonme['3c'].point.ke;
          sum += this.report.summary.mt_buonme['3c'].point.dau;
          sum += this.report.summary.mt_buonme['3c'].point.duoi;
          sum += this.report.summary.mt_buonme['3c'].point.ke;
      }
      return sum;
    },
    sum_point_4c(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['4c'].point.dat;
        sum += this.report.summary.mn['4c'].point.dx;
        sum += this.report.summary.mn['4c'].point.baolo;
        sum += this.report.summary.mn['4c'].point.dau;
        sum += this.report.summary.mn['4c'].point.duoi;
        sum += this.report.summary.mn['4c'].point.baylo;

        sum += this.report.summary.mb['4c'].point.dat;
        sum += this.report.summary.mb['4c'].point.dx;
        sum += this.report.summary.mb['4c'].point.baolo;
        sum += this.report.summary.mb['4c'].point.dau;
        sum += this.report.summary.mb['4c'].point.duoi;
        sum += this.report.summary.mb['4c'].point.baylo;

        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['4c'].point.dat;
          sum += this.report.summary.mb_ngan['4c'].point.dx;
          sum += this.report.summary.mb_ngan['4c'].point.baolo;
          sum += this.report.summary.mb_ngan['4c'].point.dau;
          sum += this.report.summary.mb_ngan['4c'].point.duoi;
          sum += this.report.summary.mb_ngan['4c'].point.baylo;
        }

        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['4c'].point.dat;
          sum += this.report.summary.mb_hanoi['4c'].point.dx;
          sum += this.report.summary.mb_hanoi['4c'].point.baolo;
          sum += this.report.summary.mb_hanoi['4c'].point.dau;
          sum += this.report.summary.mb_hanoi['4c'].point.duoi;
          sum += this.report.summary.mb_hanoi['4c'].point.baylo;
        }

        sum += this.report.summary.mt['4c'].point.dat;
        sum += this.report.summary.mt['4c'].point.dx;
        sum += this.report.summary.mt['4c'].point.baolo;
        sum += this.report.summary.mt['4c'].point.dau;
        sum += this.report.summary.mt['4c'].point.duoi;
        sum += this.report.summary.mt['4c'].point.baylo;

          sum += this.report.summary.mn_buonme['4c'].point.dat;
          sum += this.report.summary.mn_buonme['4c'].point.dx;
          sum += this.report.summary.mn_buonme['4c'].point.baolo;
          sum += this.report.summary.mn_buonme['4c'].point.dau;
          sum += this.report.summary.mn_buonme['4c'].point.duoi;
          sum += this.report.summary.mn_buonme['4c'].point.baylo;

          sum += this.report.summary.mb_buonme['4c'].point.dat;
          sum += this.report.summary.mb_buonme['4c'].point.dx;
          sum += this.report.summary.mb_buonme['4c'].point.baolo;
          sum += this.report.summary.mb_buonme['4c'].point.dau;
          sum += this.report.summary.mb_buonme['4c'].point.duoi;
          sum += this.report.summary.mb_buonme['4c'].point.baylo;

          sum += this.report.summary.mt_buonme['4c'].point.dat;
          sum += this.report.summary.mt_buonme['4c'].point.dx;
          sum += this.report.summary.mt_buonme['4c'].point.baolo;
          sum += this.report.summary.mt_buonme['4c'].point.dau;
          sum += this.report.summary.mt_buonme['4c'].point.duoi;
          sum += this.report.summary.mt_buonme['4c'].point.baylo;
      }
      return sum;
    },
    sum_cost_1c(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['1c'].cost.ngang;
        }
      }
      return sum;
    },
    sum_cost_giainhat(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        if (!this._.isUndefined(this.report.summary.mb_hanoi)){
          sum += this.report.summary.mb_hanoi['2c'].cost.giainhat;
          sum += this.report.summary.mb_hanoi['2c'].cost.daunhat;
        }
      }
      return sum;
    },
    sum_cost_2c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.report.summary)) {
        sum += this.report.summary.mn['2c'].cost.baolo;
        sum += this.report.summary.mb['2c'].cost.baolo;
        if (!this._.isUndefined(this.report.summary.mb_ngan)) {
          sum += this.report.summary.mb_ngan['2c'].cost.baolo;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost.baolo;
        }
        sum += this.report.summary.mt['2c'].cost.baolo;

        sum += this.report.summary.mn_buonme['2c'].cost.baolo;
        sum += this.report.summary.mb_buonme['2c'].cost.baolo;
        sum += this.report.summary.mt_buonme['2c'].cost.baolo;
      }
      return sum;
    },
    sum_cost_2c_dd(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost.dau;
        sum += this.report.summary.mb['2c'].cost.dau;
        sum += this.report.summary.mt['2c'].cost.dau;

        sum += this.report.summary.mn['2c'].cost.duoi;
        sum += this.report.summary.mb['2c'].cost.duoi;
        sum += this.report.summary.mt['2c'].cost.duoi;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost.dau;
          sum += this.report.summary.mb_ngan['2c'].cost.duoi;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost.dau;
          sum += this.report.summary.mb_hanoi['2c'].cost.duoi;
        }

          sum += this.report.summary.mn_buonme['2c'].cost.dau;
          sum += this.report.summary.mb_buonme['2c'].cost.dau;
          sum += this.report.summary.mt_buonme['2c'].cost.dau;

          sum += this.report.summary.mn_buonme['2c'].cost.duoi;
          sum += this.report.summary.mb_buonme['2c'].cost.duoi;
          sum += this.report.summary.mt_buonme['2c'].cost.duoi;

          sum += this.report.summary.mn_buonme['2c'].cost.ke;
          sum += this.report.summary.mb_buonme['2c'].cost.ke;
          sum += this.report.summary.mt_buonme['2c'].cost.ke;
      }
      return sum;
    },
    sum_cost_2c_dat(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost.dat;
        sum += this.report.summary.mb['2c'].cost.dat;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost.dat;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost.dat;
        }
        sum += this.report.summary.mt['2c'].cost.dat;

          sum += this.report.summary.mn_buonme['2c'].cost.dat;
          sum += this.report.summary.mb_buonme['2c'].cost.dat;
          sum += this.report.summary.mt_buonme['2c'].cost.dat;
      }
      return sum;
    },
    sum_cost_2c_dax(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost.dx;
        sum += this.report.summary.mb['2c'].cost.dx;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost.dx;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost.dx;
        }
        sum += this.report.summary.mt['2c'].cost.dx;

          sum += this.report.summary.mn_buonme['2c'].cost.dx;
          sum += this.report.summary.mb_buonme['2c'].cost.dx;
          sum += this.report.summary.mt_buonme['2c'].cost.dx;
      }
      return sum;
    },
    sum_cost_2c_dax2(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost.dx_2;
        sum += this.report.summary.mb['2c'].cost.dx_2;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost.dx_2;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost.dx_2;
        }
        sum += this.report.summary.mt['2c'].cost.dx_2;

          sum += this.report.summary.mn_buonme['2c'].cost.dx_2;
          sum += this.report.summary.mb_buonme['2c'].cost.dx_2;
          sum += this.report.summary.mt_buonme['2c'].cost.dx_2;
      }
      return sum;
    },
    sum_cost_2c_dax3(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost.dx_3;
        sum += this.report.summary.mb['2c'].cost.dx_3;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost.dx_3;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost.dx_3;
        }
        sum += this.report.summary.mt['2c'].cost.dx_3;

          sum += this.report.summary.mn_buonme['2c'].cost.dx_3;
          sum += this.report.summary.mb_buonme['2c'].cost.dx_3;
          sum += this.report.summary.mt_buonme['2c'].cost.dx_3;
      }
      return sum;
    },
    sum_cost_2c_dax4(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost.dx_4;
        sum += this.report.summary.mb['2c'].cost.dx_4;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost.dx_4;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost.dx_4;
        }
        sum += this.report.summary.mt['2c'].cost.dx_4;

          sum += this.report.summary.mn_buonme['2c'].cost.dx_4;
          sum += this.report.summary.mb_buonme['2c'].cost.dx_4;
          sum += this.report.summary.mt_buonme['2c'].cost.dx_4;
      }
      return sum;
    },
    sum_cost_2c_baylo(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost.baylo;
        sum += this.report.summary.mb['2c'].cost.baylo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost.baylo;
        }
        sum += this.report.summary.mt['2c'].cost.baylo;

          sum += this.report.summary.mn_buonme['2c'].cost.baylo;
          sum += this.report.summary.mb_buonme['2c'].cost.baylo;
          sum += this.report.summary.mt_buonme['2c'].cost.baylo;
      }
      return sum;
    },
    sum_cost_2c_tamlo(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost.tamlo;
        sum += this.report.summary.mb['2c'].cost.tamlo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost.tamlo;
        }
        sum += this.report.summary.mt['2c'].cost.tamlo;

          sum += this.report.summary.mn_buonme['2c'].cost.tamlo;
          sum += this.report.summary.mb_buonme['2c'].cost.tamlo;
          sum += this.report.summary.mt_buonme['2c'].cost.tamlo;
      }
      return sum;
    },
    sum_cost_2c_dau(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost.dau;
        sum += this.report.summary.mb['2c'].cost.dau;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost.dau;
        }
        sum += this.report.summary.mt['2c'].cost.dau;

          sum += this.report.summary.mn_buonme['2c'].cost.dau;
          sum += this.report.summary.mb_buonme['2c'].cost.dau;
          sum += this.report.summary.mt_buonme['2c'].cost.dau;
      }
      return sum;
    },
    sum_cost_2c_duoi(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost.duoi;
        sum += this.report.summary.mb['2c'].cost.duoi;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost.duoi;
        }
        sum += this.report.summary.mt['2c'].cost.duoi;

          sum += this.report.summary.mn_buonme['2c'].cost.duoi;
          sum += this.report.summary.mb_buonme['2c'].cost.duoi;
          sum += this.report.summary.mt_buonme['2c'].cost.duoi;
      }
      return sum;
    },
    sum_cost_3c_bao(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].cost.baolo;
        sum += this.report.summary.mb['3c'].cost.baolo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].cost.baolo;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['3c'].cost.baolo;
        }
        sum += this.report.summary.mt['3c'].cost.baolo;

          sum += this.report.summary.mn_buonme['3c'].cost.baolo;
          sum += this.report.summary.mb_buonme['3c'].cost.baolo;
          sum += this.report.summary.mt_buonme['3c'].cost.baolo;
      }
      return sum;
    },
    sum_cost_3c_bay(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].cost.baylo;
        sum += this.report.summary.mb['3c'].cost.baylo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].cost.baylo;
        }
        sum += this.report.summary.mt['3c'].cost.baylo;

          sum += this.report.summary.mn_buonme['3c'].cost.baylo;
          sum += this.report.summary.mb_buonme['3c'].cost.baylo;
          sum += this.report.summary.mt_buonme['3c'].cost.baylo;
      }
      return sum;
    },
    sum_cost_3c_xc(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].cost.dau;
        sum += this.report.summary.mn['3c'].cost.duoi;
        sum += this.report.summary.mb['3c'].cost.dau;
        sum += this.report.summary.mb['3c'].cost.duoi;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].cost.dau;
          sum += this.report.summary.mb_ngan['3c'].cost.duoi;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['3c'].cost.dau;
          sum += this.report.summary.mb_hanoi['3c'].cost.duoi;
        }
        sum += this.report.summary.mt['3c'].cost.dau;
        sum += this.report.summary.mt['3c'].cost.duoi;

          sum += this.report.summary.mn_buonme['3c'].cost.dau;
          sum += this.report.summary.mn_buonme['3c'].cost.duoi;
          sum += this.report.summary.mn_buonme['3c'].cost.ke;
          sum += this.report.summary.mb_buonme['3c'].cost.dau;
          sum += this.report.summary.mb_buonme['3c'].cost.duoi;
          sum += this.report.summary.mb_buonme['3c'].cost.ke;
          sum += this.report.summary.mt_buonme['3c'].cost.dau;
          sum += this.report.summary.mt_buonme['3c'].cost.duoi;
          sum += this.report.summary.mt_buonme['3c'].cost.ke;
      }
      return sum;
    },
    sum_cost_4c(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['4c'].cost.dat;
        sum += this.report.summary.mn['4c'].cost.dx;
        sum += this.report.summary.mn['4c'].cost.baolo;
        sum += this.report.summary.mn['4c'].cost.dau;
        sum += this.report.summary.mn['4c'].cost.duoi;
        sum += this.report.summary.mn['4c'].cost.baylo;

        sum += this.report.summary.mb['4c'].cost.dat;
        sum += this.report.summary.mb['4c'].cost.dx;
        sum += this.report.summary.mb['4c'].cost.baolo;
        sum += this.report.summary.mb['4c'].cost.dau;
        sum += this.report.summary.mb['4c'].cost.duoi;
        sum += this.report.summary.mb['4c'].cost.baylo;

        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['4c'].cost.dat;
          sum += this.report.summary.mb_ngan['4c'].cost.dx;
          sum += this.report.summary.mb_ngan['4c'].cost.baolo;
          sum += this.report.summary.mb_ngan['4c'].cost.dau;
          sum += this.report.summary.mb_ngan['4c'].cost.duoi;
          sum += this.report.summary.mb_ngan['4c'].cost.baylo;
        }

        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['4c'].cost.dat;
          sum += this.report.summary.mb_hanoi['4c'].cost.dx;
          sum += this.report.summary.mb_hanoi['4c'].cost.baolo;
          sum += this.report.summary.mb_hanoi['4c'].cost.dau;
          sum += this.report.summary.mb_hanoi['4c'].cost.duoi;
          sum += this.report.summary.mb_hanoi['4c'].cost.baylo;
        }

        sum += this.report.summary.mt['4c'].cost.dat;
        sum += this.report.summary.mt['4c'].cost.dx;
        sum += this.report.summary.mt['4c'].cost.baolo;
        sum += this.report.summary.mt['4c'].cost.dau;
        sum += this.report.summary.mt['4c'].cost.duoi;
        sum += this.report.summary.mt['4c'].cost.baylo;

          sum += this.report.summary.mn_buonme['4c'].cost.dat;
          sum += this.report.summary.mn_buonme['4c'].cost.dx;
          sum += this.report.summary.mn_buonme['4c'].cost.baolo;
          sum += this.report.summary.mn_buonme['4c'].cost.dau;
          sum += this.report.summary.mn_buonme['4c'].cost.duoi;
          sum += this.report.summary.mn_buonme['4c'].cost.baylo;
          sum += this.report.summary.mb_buonme['4c'].cost.dat;
          sum += this.report.summary.mb_buonme['4c'].cost.dx;
          sum += this.report.summary.mb_buonme['4c'].cost.baolo;
          sum += this.report.summary.mb_buonme['4c'].cost.dau;
          sum += this.report.summary.mb_buonme['4c'].cost.duoi;
          sum += this.report.summary.mb_buonme['4c'].cost.baylo;
          sum += this.report.summary.mt_buonme['4c'].cost.dat;
          sum += this.report.summary.mt_buonme['4c'].cost.dx;
          sum += this.report.summary.mt_buonme['4c'].cost.baolo;
          sum += this.report.summary.mt_buonme['4c'].cost.dau;
          sum += this.report.summary.mt_buonme['4c'].cost.duoi;
          sum += this.report.summary.mt_buonme['4c'].cost.baylo;
      }
      return sum;
    },
    sum_cost() {
      let sum = 0;
      sum += this.sum_cost_1c;
      sum += this.sum_cost_giainhat;
      sum += this.sum_cost_2c_bao;
      sum += this.sum_cost_2c_dd;
      sum += this.sum_cost_2c_dat;
      sum += this.sum_cost_2c_dax;
      sum += this.sum_cost_2c_dax2;
      sum += this.sum_cost_2c_dax3;
      sum += this.sum_cost_2c_dax4;
      sum += this.sum_cost_2c_baylo;
      sum += this.sum_cost_2c_tamlo;
      sum += this.sum_cost_3c_bao;
      sum += this.sum_cost_3c_bay;
      sum += this.sum_cost_3c_xc;
      sum += this.sum_cost_4c;
      return sum;
    },
    sum_cost_without_rate_1c(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['1c'].cost_without_rate.ngang;
        }
      }
      return sum;
    },
    sum_cost_without_rate_giainhat(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        if (!this._.isUndefined(this.report.summary.mb_hanoi)){
          sum += this.report.summary.mb_hanoi['2c'].cost_without_rate.giainhat;
          sum += this.report.summary.mb_hanoi['2c'].cost_without_rate.daunhat;
        }
      }
      return sum;
    },
    sum_cost_without_rate_2c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.report.summary)) {
        sum += this.report.summary.mn['2c'].cost_without_rate.baolo;
        sum += this.report.summary.mb['2c'].cost_without_rate.baolo;
        if (!this._.isUndefined(this.report.summary.mb_ngan)) {
          sum += this.report.summary.mb_ngan['2c'].cost_without_rate.baolo;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost_without_rate.baolo;
        }
        sum += this.report.summary.mt['2c'].cost_without_rate.baolo;

        sum += this.report.summary.mn_buonme['2c'].cost_without_rate.baolo;
        sum += this.report.summary.mb_buonme['2c'].cost_without_rate.baolo;
        sum += this.report.summary.mt_buonme['2c'].cost_without_rate.baolo;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dd(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost_without_rate.dau;
        sum += this.report.summary.mb['2c'].cost_without_rate.dau;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost_without_rate.dau;
          sum += this.report.summary.mb_ngan['2c'].cost_without_rate.duoi;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost_without_rate.dau;
          sum += this.report.summary.mb_hanoi['2c'].cost_without_rate.duoi;
        }
        sum += this.report.summary.mt['2c'].cost_without_rate.dau;

        sum += this.report.summary.mn['2c'].cost_without_rate.duoi;
        sum += this.report.summary.mb['2c'].cost_without_rate.duoi;
        sum += this.report.summary.mt['2c'].cost_without_rate.duoi;

          sum += this.report.summary.mn_buonme['2c'].cost_without_rate.dau;
          sum += this.report.summary.mb_buonme['2c'].cost_without_rate.dau;
          sum += this.report.summary.mt_buonme['2c'].cost_without_rate.dau;

          sum += this.report.summary.mn_buonme['2c'].cost_without_rate.duoi;
          sum += this.report.summary.mb_buonme['2c'].cost_without_rate.duoi;
          sum += this.report.summary.mt_buonme['2c'].cost_without_rate.duoi;

          sum += this.report.summary.mn_buonme['2c'].cost_without_rate.ke;
          sum += this.report.summary.mb_buonme['2c'].cost_without_rate.ke;
          sum += this.report.summary.mt_buonme['2c'].cost_without_rate.ke;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dat(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost_without_rate.dat;
        sum += this.report.summary.mb['2c'].cost_without_rate.dat;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost_without_rate.dat;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost_without_rate.dat;
        }
        sum += this.report.summary.mt['2c'].cost_without_rate.dat;

          sum += this.report.summary.mn_buonme['2c'].cost_without_rate.dat;
          sum += this.report.summary.mb_buonme['2c'].cost_without_rate.dat;
          sum += this.report.summary.mt_buonme['2c'].cost_without_rate.dat;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dax(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost_without_rate.dx;
        sum += this.report.summary.mb['2c'].cost_without_rate.dx;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost_without_rate.dx;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost_without_rate.dx;
        }
        sum += this.report.summary.mt['2c'].cost_without_rate.dx;

          sum += this.report.summary.mn_buonme['2c'].cost_without_rate.dx;
          sum += this.report.summary.mb_buonme['2c'].cost_without_rate.dx;
          sum += this.report.summary.mt_buonme['2c'].cost_without_rate.dx;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dax2(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost_without_rate.dx_2;
        sum += this.report.summary.mb['2c'].cost_without_rate.dx_2;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost_without_rate.dx_2;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost_without_rate.dx_2;
        }
        sum += this.report.summary.mt['2c'].cost_without_rate.dx_2;

          sum += this.report.summary.mn_buonme['2c'].cost_without_rate.dx_2;
          sum += this.report.summary.mb_buonme['2c'].cost_without_rate.dx_2;
          sum += this.report.summary.mt_buonme['2c'].cost_without_rate.dx_2;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dax3(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost_without_rate.dx_3;
        sum += this.report.summary.mb['2c'].cost_without_rate.dx_3;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost_without_rate.dx_3;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost_without_rate.dx_3;
        }
        sum += this.report.summary.mt['2c'].cost_without_rate.dx_3;

          sum += this.report.summary.mn_buonme['2c'].cost_without_rate.dx_3;
          sum += this.report.summary.mb_buonme['2c'].cost_without_rate.dx_3;
          sum += this.report.summary.mt_buonme['2c'].cost_without_rate.dx_3;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dax4(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost_without_rate.dx_4;
        sum += this.report.summary.mb['2c'].cost_without_rate.dx_4;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost_without_rate.dx_4;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].cost_without_rate.dx_4;
        }
        sum += this.report.summary.mt['2c'].cost_without_rate.dx_4;

          sum += this.report.summary.mn_buonme['2c'].cost_without_rate.dx_4;
          sum += this.report.summary.mb_buonme['2c'].cost_without_rate.dx_4;
          sum += this.report.summary.mt_buonme['2c'].cost_without_rate.dx_4;
      }
      return sum;
    },
    sum_cost_without_rate_2c_baylo(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost_without_rate.baylo;
        sum += this.report.summary.mb['2c'].cost_without_rate.baylo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost_without_rate.baylo;
        }
        sum += this.report.summary.mt['2c'].cost_without_rate.baylo;

          sum += this.report.summary.mn_buonme['2c'].cost_without_rate.baylo;
          sum += this.report.summary.mb_buonme['2c'].cost_without_rate.baylo;
          sum += this.report.summary.mt_buonme['2c'].cost_without_rate.baylo;
      }
      return sum;
    },
    sum_cost_without_rate_2c_tamlo(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].cost_without_rate.tamlo;
        sum += this.report.summary.mb['2c'].cost_without_rate.tamlo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].cost_without_rate.tamlo;
        }
        sum += this.report.summary.mt['2c'].cost_without_rate.tamlo;

          sum += this.report.summary.mn_buonme['2c'].cost_without_rate.tamlo;
          sum += this.report.summary.mb_buonme['2c'].cost_without_rate.tamlo;
          sum += this.report.summary.mt_buonme['2c'].cost_without_rate.tamlo;
      }
      return sum;
    },
    sum_cost_without_rate_3c_bao(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].cost_without_rate.baolo;
        sum += this.report.summary.mb['3c'].cost_without_rate.baolo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].cost_without_rate.baolo;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['3c'].cost_without_rate.baolo;
        }
        sum += this.report.summary.mt['3c'].cost_without_rate.baolo;

          sum += this.report.summary.mn_buonme['3c'].cost_without_rate.baolo;
          sum += this.report.summary.mb_buonme['3c'].cost_without_rate.baolo;
          sum += this.report.summary.mt_buonme['3c'].cost_without_rate.baolo;
      }
      return sum;
    },
    sum_cost_without_rate_3c_bay(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].cost_without_rate.baylo;
        sum += this.report.summary.mb['3c'].cost_without_rate.baylo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].cost_without_rate.baylo;
        }
        sum += this.report.summary.mt['3c'].cost_without_rate.baylo;

          sum += this.report.summary.mn_buonme['3c'].cost_without_rate.baylo;
          sum += this.report.summary.mb_buonme['3c'].cost_without_rate.baylo;
          sum += this.report.summary.mt_buonme['3c'].cost_without_rate.baylo;
      }
      return sum;
    },
    sum_cost_without_rate_3c_xc(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].cost_without_rate.dau;
        sum += this.report.summary.mn['3c'].cost_without_rate.duoi;
        sum += this.report.summary.mb['3c'].cost_without_rate.dau;
        sum += this.report.summary.mb['3c'].cost_without_rate.duoi;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].cost_without_rate.dau;
          sum += this.report.summary.mb_ngan['3c'].cost_without_rate.duoi;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['3c'].cost_without_rate.dau;
          sum += this.report.summary.mb_hanoi['3c'].cost_without_rate.duoi;
        }
        sum += this.report.summary.mt['3c'].cost_without_rate.dau;
        sum += this.report.summary.mt['3c'].cost_without_rate.duoi;

          sum += this.report.summary.mn_buonme['3c'].cost_without_rate.dau;
          sum += this.report.summary.mn_buonme['3c'].cost_without_rate.duoi;
          sum += this.report.summary.mn_buonme['3c'].cost_without_rate.ke;
          sum += this.report.summary.mb_buonme['3c'].cost_without_rate.dau;
          sum += this.report.summary.mb_buonme['3c'].cost_without_rate.duoi;
          sum += this.report.summary.mb_buonme['3c'].cost_without_rate.ke;
          sum += this.report.summary.mt_buonme['3c'].cost_without_rate.dau;
          sum += this.report.summary.mt_buonme['3c'].cost_without_rate.duoi;
          sum += this.report.summary.mt_buonme['3c'].cost_without_rate.ke;
      }
      return sum;
    },
    sum_cost_without_rate_4c(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['4c'].cost_without_rate.dat;
        sum += this.report.summary.mn['4c'].cost_without_rate.dx;
        sum += this.report.summary.mn['4c'].cost_without_rate.baolo;
        sum += this.report.summary.mn['4c'].cost_without_rate.dau;
        sum += this.report.summary.mn['4c'].cost_without_rate.duoi;
        sum += this.report.summary.mn['4c'].cost_without_rate.baylo;

        sum += this.report.summary.mb['4c'].cost_without_rate.dat;
        sum += this.report.summary.mb['4c'].cost_without_rate.dx;
        sum += this.report.summary.mb['4c'].cost_without_rate.baolo;
        sum += this.report.summary.mb['4c'].cost_without_rate.dau;
        sum += this.report.summary.mb['4c'].cost_without_rate.duoi;
        sum += this.report.summary.mb['4c'].cost_without_rate.baylo;

        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['4c'].cost_without_rate.dat;
          sum += this.report.summary.mb_ngan['4c'].cost_without_rate.dx;
          sum += this.report.summary.mb_ngan['4c'].cost_without_rate.baolo;
          sum += this.report.summary.mb_ngan['4c'].cost_without_rate.dau;
          sum += this.report.summary.mb_ngan['4c'].cost_without_rate.duoi;
          sum += this.report.summary.mb_ngan['4c'].cost_without_rate.baylo;
        }

        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['4c'].cost_without_rate.dat;
          sum += this.report.summary.mb_hanoi['4c'].cost_without_rate.dx;
          sum += this.report.summary.mb_hanoi['4c'].cost_without_rate.baolo;
          sum += this.report.summary.mb_hanoi['4c'].cost_without_rate.dau;
          sum += this.report.summary.mb_hanoi['4c'].cost_without_rate.duoi;
          sum += this.report.summary.mb_hanoi['4c'].cost_without_rate.baylo;
        }

        sum += this.report.summary.mt['4c'].cost_without_rate.dat;
        sum += this.report.summary.mt['4c'].cost_without_rate.dx;
        sum += this.report.summary.mt['4c'].cost_without_rate.baolo;
        sum += this.report.summary.mt['4c'].cost_without_rate.dau;
        sum += this.report.summary.mt['4c'].cost_without_rate.duoi;
        sum += this.report.summary.mt['4c'].cost_without_rate.baylo;

          sum += this.report.summary.mn_buonme['4c'].cost_without_rate.dat;
          sum += this.report.summary.mn_buonme['4c'].cost_without_rate.dx;
          sum += this.report.summary.mn_buonme['4c'].cost_without_rate.baolo;
          sum += this.report.summary.mn_buonme['4c'].cost_without_rate.dau;
          sum += this.report.summary.mn_buonme['4c'].cost_without_rate.duoi;
          sum += this.report.summary.mn_buonme['4c'].cost_without_rate.baylo;
          sum += this.report.summary.mb_buonme['4c'].cost_without_rate.dat;
          sum += this.report.summary.mb_buonme['4c'].cost_without_rate.dx;
          sum += this.report.summary.mb_buonme['4c'].cost_without_rate.baolo;
          sum += this.report.summary.mb_buonme['4c'].cost_without_rate.dau;
          sum += this.report.summary.mb_buonme['4c'].cost_without_rate.duoi;
          sum += this.report.summary.mb_buonme['4c'].cost_without_rate.baylo;
          sum += this.report.summary.mt_buonme['4c'].cost_without_rate.dat;
          sum += this.report.summary.mt_buonme['4c'].cost_without_rate.dx;
          sum += this.report.summary.mt_buonme['4c'].cost_without_rate.baolo;
          sum += this.report.summary.mt_buonme['4c'].cost_without_rate.dau;
          sum += this.report.summary.mt_buonme['4c'].cost_without_rate.duoi;
          sum += this.report.summary.mt_buonme['4c'].cost_without_rate.baylo;
      }
      return sum;
    },
    sum_cost_without_rate(){
      let sum = 0;
      sum += this.sum_cost_without_rate_1c;
      sum += this.sum_cost_without_rate_giainhat;
      sum += this.sum_cost_without_rate_2c_bao;
      sum += this.sum_cost_without_rate_2c_dd;
      sum += this.sum_cost_without_rate_2c_dat;
      sum += this.sum_cost_without_rate_2c_dax;
      sum += this.sum_cost_without_rate_2c_dax2;
      sum += this.sum_cost_without_rate_2c_dax3;
      sum += this.sum_cost_without_rate_2c_dax4;
      sum += this.sum_cost_without_rate_2c_baylo;
      sum += this.sum_cost_without_rate_2c_tamlo;
      sum += this.sum_cost_without_rate_3c_bao;
      sum += this.sum_cost_without_rate_3c_bay;
      sum += this.sum_cost_without_rate_3c_xc;
      sum += this.sum_cost_without_rate_4c;
      return sum;
    },
    sum_win_1c(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['1c'].win.ngang;
        }
      }
      return sum;
    },
    sum_win_giainhat() {
      let sum = 0;
      if (!this._.isEmpty(this.report.summary)) {
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win.giainhat;
          sum += this.report.summary.mb_hanoi['2c'].win.daunhat;
        }
      }
      return sum;
    },
    sum_win_2c_bao(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.baolo;
        sum += this.report.summary.mb['2c'].win.baolo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.baolo;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win.baolo;
        }
        sum += this.report.summary.mt['2c'].win.baolo;

          sum += this.report.summary.mn_buonme['2c'].win.baolo;
          sum += this.report.summary.mb_buonme['2c'].win.baolo;
          sum += this.report.summary.mt_buonme['2c'].win.baolo;
      }
      return sum;
    },
    sum_win_2c_dd(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.dau;
        sum += this.report.summary.mb['2c'].win.dau;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.dau;
          sum += this.report.summary.mb_ngan['2c'].win.duoi;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win.dau;
          sum += this.report.summary.mb_hanoi['2c'].win.duoi;
        }
        sum += this.report.summary.mt['2c'].win.dau;

        sum += this.report.summary.mn['2c'].win.duoi;
        sum += this.report.summary.mb['2c'].win.duoi;
        sum += this.report.summary.mt['2c'].win.duoi;

          sum += this.report.summary.mn_buonme['2c'].win.dau;
          sum += this.report.summary.mb_buonme['2c'].win.dau;
          sum += this.report.summary.mt_buonme['2c'].win.dau;
          sum += this.report.summary.mn_buonme['2c'].win.duoi;
          sum += this.report.summary.mb_buonme['2c'].win.duoi;
          sum += this.report.summary.mt_buonme['2c'].win.duoi;
          sum += this.report.summary.mn_buonme['2c'].win.ke;
          sum += this.report.summary.mb_buonme['2c'].win.ke;
          sum += this.report.summary.mt_buonme['2c'].win.ke;
      }
      return sum;
    },
    sum_win_2c_ui(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += (this._.isNumber(this.report.summary.mn['2c'].win.ui)) ? this.report.summary.mn['2c'].win.ui : 0;
        sum += (this._.isNumber(this.report.summary.mt['2c'].win.ui)) ? this.report.summary.mt['2c'].win.ui : 0;

          sum += (this._.isNumber(this.report.summary.mn_buonme['2c'].win.ui)) ? this.report.summary.mn_buonme['2c'].win.ui : 0;
          sum += (this._.isNumber(this.report.summary.mt_buonme['2c'].win.ui)) ? this.report.summary.mt_buonme['2c'].win.ui : 0;
      }
      return sum;
    },
    sum_win_2c_dat(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.dat;
        sum += this.report.summary.mb['2c'].win.dat;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.dat;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win.dat;
        }
        sum += this.report.summary.mt['2c'].win.dat;

          sum += this.report.summary.mn_buonme['2c'].win.dat;
          sum += this.report.summary.mb_buonme['2c'].win.dat;
          sum += this.report.summary.mt_buonme['2c'].win.dat;
      }
      return sum;
    },
    sum_win_2c_dax(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.dx;
        sum += this.report.summary.mb['2c'].win.dx;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.dx;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win.dx;
        }
        sum += this.report.summary.mt['2c'].win.dx;

          sum += this.report.summary.mn_buonme['2c'].win.dx;
          sum += this.report.summary.mb_buonme['2c'].win.dx;
          sum += this.report.summary.mt_buonme['2c'].win.dx;
      }
      return sum;
    },
    sum_win_2c_dax2(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.dx_2;
        sum += this.report.summary.mb['2c'].win.dx_2;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.dx_2;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win.dx_2;
        }
        sum += this.report.summary.mt['2c'].win.dx_2;

          sum += this.report.summary.mn_buonme['2c'].win.dx_2;
          sum += this.report.summary.mb_buonme['2c'].win.dx_2;
          sum += this.report.summary.mt_buonme['2c'].win.dx_2;
      }
      return sum;
    },
    sum_win_2c_dax3(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.dx_3;
        sum += this.report.summary.mb['2c'].win.dx_3;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.dx_3;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win.dx_3;
        }
        sum += this.report.summary.mt['2c'].win.dx_3;

          sum += this.report.summary.mn_buonme['2c'].win.dx_3;
          sum += this.report.summary.mb_buonme['2c'].win.dx_3;
          sum += this.report.summary.mt_buonme['2c'].win.dx_3;
      }
      return sum;
    },
    sum_win_2c_dax4(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.dx_4;
        sum += this.report.summary.mb['2c'].win.dx_4;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.dx_4;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win.dx_4;
        }
        sum += this.report.summary.mt['2c'].win.dx_4;

          sum += this.report.summary.mn_buonme['2c'].win.dx_4;
          sum += this.report.summary.mb_buonme['2c'].win.dx_4;
          sum += this.report.summary.mt_buonme['2c'].win.dx_4;
      }
      return sum;
    },
    sum_win_2c_baylo(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.baylo;
        sum += this.report.summary.mb['2c'].win.baylo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.baylo;
        }
        sum += this.report.summary.mt['2c'].win.baylo;

          sum += this.report.summary.mn_buonme['2c'].win.baylo;
          sum += this.report.summary.mb_buonme['2c'].win.baylo;
          sum += this.report.summary.mt_buonme['2c'].win.baylo;
      }
      return sum;
    },
    sum_win_2c_tamlo(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.tamlo;
        sum += this.report.summary.mb['2c'].win.tamlo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.tamlo;
        }
        sum += this.report.summary.mt['2c'].win.tamlo;

          sum += this.report.summary.mn_buonme['2c'].win.tamlo;
          sum += this.report.summary.mb_buonme['2c'].win.tamlo;
          sum += this.report.summary.mt_buonme['2c'].win.tamlo;
      }
      return sum;
    },
    sum_win_2c_dau(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.dau;
        sum += this.report.summary.mb['2c'].win.dau;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.dau;
        }
        sum += this.report.summary.mt['2c'].win.dau;

          sum += this.report.summary.mn_buonme['2c'].win.dau;
          sum += this.report.summary.mb_buonme['2c'].win.dau;
          sum += this.report.summary.mt_buonme['2c'].win.dau;
      }
      return sum;
    },
    sum_win_2c_duoi(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win.duoi;
        sum += this.report.summary.mb['2c'].win.duoi;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win.duoi;
        }
        sum += this.report.summary.mt['2c'].win.duoi;

          sum += this.report.summary.mn_buonme['2c'].win.duoi;
          sum += this.report.summary.mb_buonme['2c'].win.duoi;
          sum += this.report.summary.mt_buonme['2c'].win.duoi;
      }
      return sum;
    },
    sum_win_3c_bao(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].win.baolo;
        sum += this.report.summary.mb['3c'].win.baolo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].win.baolo;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['3c'].win.baolo;
        }
        sum += this.report.summary.mt['3c'].win.baolo;

          sum += this.report.summary.mn_buonme['3c'].win.baolo;
          sum += this.report.summary.mb_buonme['3c'].win.baolo;
          sum += this.report.summary.mt_buonme['3c'].win.baolo;
      }
      return sum;
    },
    sum_win_3c_bay(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].win.baylo;
        sum += this.report.summary.mb['3c'].win.baylo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].win.baylo;
        }
        sum += this.report.summary.mt['3c'].win.baylo;

          sum += this.report.summary.mn_buonme['3c'].win.baylo;
          sum += this.report.summary.mb_buonme['3c'].win.baylo;
          sum += this.report.summary.mt_buonme['3c'].win.baylo;
      }
      return sum;
    },
    sum_win_3c_xc(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].win.dau;
        sum += this.report.summary.mn['3c'].win.duoi;
        sum += this.report.summary.mb['3c'].win.dau;
        sum += this.report.summary.mb['3c'].win.duoi;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].win.dau;
          sum += this.report.summary.mb_ngan['3c'].win.duoi;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['3c'].win.dau;
          sum += this.report.summary.mb_hanoi['3c'].win.duoi;
        }
        sum += this.report.summary.mt['3c'].win.dau;
        sum += this.report.summary.mt['3c'].win.duoi;

          sum += this.report.summary.mn_buonme['3c'].win.dau;
          sum += this.report.summary.mn_buonme['3c'].win.duoi;
          sum += this.report.summary.mn_buonme['3c'].win.ke;
          sum += this.report.summary.mb_buonme['3c'].win.dau;
          sum += this.report.summary.mb_buonme['3c'].win.duoi;
          sum += this.report.summary.mb_buonme['3c'].win.ke;
          sum += this.report.summary.mt_buonme['3c'].win.dau;
          sum += this.report.summary.mt_buonme['3c'].win.duoi;
          sum += this.report.summary.mt_buonme['3c'].win.ke;
      }
      return sum;
    },
    sum_win_4c(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['4c'].win.dat;
        sum += this.report.summary.mn['4c'].win.dx;
        sum += this.report.summary.mn['4c'].win.baolo;
        sum += this.report.summary.mn['4c'].win.dau;
        sum += this.report.summary.mn['4c'].win.duoi;
        sum += this.report.summary.mn['4c'].win.baylo;

        sum += this.report.summary.mb['4c'].win.dat;
        sum += this.report.summary.mb['4c'].win.dx;
        sum += this.report.summary.mb['4c'].win.baolo;
        sum += this.report.summary.mb['4c'].win.dau;
        sum += this.report.summary.mb['4c'].win.duoi;
        sum += this.report.summary.mb['4c'].win.baylo;

        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['4c'].win.dat;
          sum += this.report.summary.mb_ngan['4c'].win.dx;
          sum += this.report.summary.mb_ngan['4c'].win.baolo;
          sum += this.report.summary.mb_ngan['4c'].win.dau;
          sum += this.report.summary.mb_ngan['4c'].win.duoi;
          sum += this.report.summary.mb_ngan['4c'].win.baylo;
        }

        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['4c'].win.dat;
          sum += this.report.summary.mb_hanoi['4c'].win.dx;
          sum += this.report.summary.mb_hanoi['4c'].win.baolo;
          sum += this.report.summary.mb_hanoi['4c'].win.dau;
          sum += this.report.summary.mb_hanoi['4c'].win.duoi;
          sum += this.report.summary.mb_hanoi['4c'].win.baylo;
        }

        sum += this.report.summary.mt['4c'].win.dat;
        sum += this.report.summary.mt['4c'].win.dx;
        sum += this.report.summary.mt['4c'].win.baolo;
        sum += this.report.summary.mt['4c'].win.dau;
        sum += this.report.summary.mt['4c'].win.duoi;
        sum += this.report.summary.mt['4c'].win.baylo;

          sum += this.report.summary.mn_buonme['4c'].win.dat;
          sum += this.report.summary.mn_buonme['4c'].win.dx;
          sum += this.report.summary.mn_buonme['4c'].win.baolo;
          sum += this.report.summary.mn_buonme['4c'].win.dau;
          sum += this.report.summary.mn_buonme['4c'].win.duoi;
          sum += this.report.summary.mn_buonme['4c'].win.baylo;
          sum += this.report.summary.mb_buonme['4c'].win.dat;
          sum += this.report.summary.mb_buonme['4c'].win.dx;
          sum += this.report.summary.mb_buonme['4c'].win.baolo;
          sum += this.report.summary.mb_buonme['4c'].win.dau;
          sum += this.report.summary.mb_buonme['4c'].win.duoi;
          sum += this.report.summary.mb_buonme['4c'].win.baylo;
          sum += this.report.summary.mt_buonme['4c'].win.dat;
          sum += this.report.summary.mt_buonme['4c'].win.dx;
          sum += this.report.summary.mt_buonme['4c'].win.baolo;
          sum += this.report.summary.mt_buonme['4c'].win.dau;
          sum += this.report.summary.mt_buonme['4c'].win.duoi;
          sum += this.report.summary.mt_buonme['4c'].win.baylo;
      }
      return sum;
    },
    sum_win() {
      let sum = 0;
      sum += this.sum_win_1c;
      sum += this.sum_win_giainhat;
      sum += this.sum_win_2c_bao;
      sum += this.sum_win_2c_dd;
      sum += this.sum_win_2c_ui;
      sum += this.sum_win_2c_dat;
      sum += this.sum_win_2c_dax;
      sum += this.sum_win_2c_dax2;
      sum += this.sum_win_2c_dax3;
      sum += this.sum_win_2c_dax4;
      sum += this.sum_win_2c_baylo;
      sum += this.sum_win_2c_tamlo;
      sum += this.sum_win_3c_bao;
      sum += this.sum_win_3c_bay;
      sum += this.sum_win_3c_xc;
      sum += this.sum_win_4c;
      return sum;
    },
    sum_win_without_win_rate_1c(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary) && !this._.isUndefined(this.report.summary.mb_ngan)){
        sum += this.report.summary.mb_ngan['1c'].win_without_win_rate.ngang;
      }
      return sum;
    },
    sum_win_without_win_rate_giainhat() {
      let sum = 0;
      if (!this._.isEmpty(this.report.summary) && !this._.isUndefined(this.report.summary.mb_hanoi)) {
        sum += this.report.summary.mb_hanoi['2c'].win_without_win_rate.giainhat;
        sum += this.report.summary.mb_hanoi['2c'].win_without_win_rate.daunhat;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_bao(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.baolo;
        sum += this.report.summary.mb['2c'].win_without_win_rate.baolo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.baolo;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win_without_win_rate.baolo;
        }
        sum += this.report.summary.mt['2c'].win_without_win_rate.baolo;

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.baolo;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.baolo;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.baolo;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dd(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.dau;
        sum += this.report.summary.mb['2c'].win_without_win_rate.dau;
        sum += this.report.summary.mt['2c'].win_without_win_rate.dau;

        sum += this.report.summary.mn['2c'].win_without_win_rate.duoi;
        sum += this.report.summary.mb['2c'].win_without_win_rate.duoi;
        sum += this.report.summary.mt['2c'].win_without_win_rate.duoi;

        if (!this._.isUndefined(this.report.summary.mb_ngan)) {
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.dau;
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.duoi;
        }

        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win_without_win_rate.dau;
          sum += this.report.summary.mb_hanoi['2c'].win_without_win_rate.duoi;
        }

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.dau;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.dau;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.dau;
          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.duoi;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.duoi;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.duoi;
          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.ke;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.ke;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.ke;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dat(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.dat;
        sum += this.report.summary.mb['2c'].win_without_win_rate.dat;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.dat;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win_without_win_rate.dat;
        }
        sum += this.report.summary.mt['2c'].win_without_win_rate.dat;

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.dat;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.dat;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.dat;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dax(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.dx;
        sum += this.report.summary.mb['2c'].win_without_win_rate.dx;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.dx;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win_without_win_rate.dx;
        }
        sum += this.report.summary.mt['2c'].win_without_win_rate.dx;

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.dx;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.dx;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.dx;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dax2(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.dx_2;
        sum += this.report.summary.mb['2c'].win_without_win_rate.dx_2;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.dx_2;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win_without_win_rate.dx_2;
        }
        sum += this.report.summary.mt['2c'].win_without_win_rate.dx_2;

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.dx_2;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.dx_2;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.dx_2;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dax3(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.dx_3;
        sum += this.report.summary.mb['2c'].win_without_win_rate.dx_3;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.dx_3;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win_without_win_rate.dx_3;
        }
        sum += this.report.summary.mt['2c'].win_without_win_rate.dx_3;

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.dx_3;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.dx_3;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.dx_3;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dax4(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.dx_4;
        sum += this.report.summary.mb['2c'].win_without_win_rate.dx_4;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.dx_4;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['2c'].win_without_win_rate.dx_4;
        }
        sum += this.report.summary.mt['2c'].win_without_win_rate.dx_4;

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.dx_4;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.dx_4;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.dx_4;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_baylo(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.baylo;
        sum += this.report.summary.mb['2c'].win_without_win_rate.baylo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.baylo;
        }
        sum += this.report.summary.mt['2c'].win_without_win_rate.baylo;

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.baylo;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.baylo;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.baylo;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_tamlo(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.tamlo;
        sum += this.report.summary.mb['2c'].win_without_win_rate.tamlo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.tamlo;
        }
        sum += this.report.summary.mt['2c'].win_without_win_rate.tamlo;

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.tamlo;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.tamlo;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.tamlo;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_ui(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += (this._.isNumber(this.report.summary.mn['2c'].win_without_win_rate.ui) && this.report.summary.mn['2c'].win_without_win_rate.ui !== 0) ? this.report.summary.mn['2c'].win_without_win_rate.ui : 0;
        sum += (this._.isNumber(this.report.summary.mt['2c'].win_without_win_rate.ui) && this.report.summary.mt['2c'].win_without_win_rate.ui !== 0) ? this.report.summary.mt['2c'].win_without_win_rate.ui : 0;

          sum += (this._.isNumber(this.report.summary.mn_buonme['2c'].win_without_win_rate.ui) && this.report.summary.mn_buonme['2c'].win_without_win_rate.ui !== 0) ? this.report.summary.mn_buonme['2c'].win_without_win_rate.ui : 0;
          sum += (this._.isNumber(this.report.summary.mt_buonme['2c'].win_without_win_rate.ui) && this.report.summary.mt_buonme['2c'].win_without_win_rate.ui !== 0) ? this.report.summary.mt_buonme['2c'].win_without_win_rate.ui : 0;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dau(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.dau;
        sum += this.report.summary.mb['2c'].win_without_win_rate.dau;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.dau;
        }
        sum += this.report.summary.mt['2c'].win_without_win_rate.dau;

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.dau;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.dau;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.dau;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_duoi(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['2c'].win_without_win_rate.duoi;
        sum += this.report.summary.mb['2c'].win_without_win_rate.duoi;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['2c'].win_without_win_rate.duoi;
        }
        sum += this.report.summary.mt['2c'].win_without_win_rate.duoi;

          sum += this.report.summary.mn_buonme['2c'].win_without_win_rate.duoi;
          sum += this.report.summary.mb_buonme['2c'].win_without_win_rate.duoi;
          sum += this.report.summary.mt_buonme['2c'].win_without_win_rate.duoi;
      }
      return sum;
    },
    sum_win_without_win_rate_3c_bao(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].win_without_win_rate.baolo;
        sum += this.report.summary.mb['3c'].win_without_win_rate.baolo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].win_without_win_rate.baolo;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['3c'].win_without_win_rate.baolo;
        }
        sum += this.report.summary.mt['3c'].win_without_win_rate.baolo;

          sum += this.report.summary.mn_buonme['3c'].win_without_win_rate.baolo;
          sum += this.report.summary.mb_buonme['3c'].win_without_win_rate.baolo;
          sum += this.report.summary.mt_buonme['3c'].win_without_win_rate.baolo;
      }
      return sum;
    },
    sum_win_without_win_rate_3c_bay(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].win_without_win_rate.baylo;
        sum += this.report.summary.mb['3c'].win_without_win_rate.baylo;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].win_without_win_rate.baylo;
        }
        sum += this.report.summary.mt['3c'].win_without_win_rate.baylo;

          sum += this.report.summary.mn_buonme['3c'].win_without_win_rate.baylo;
          sum += this.report.summary.mb_buonme['3c'].win_without_win_rate.baylo;
          sum += this.report.summary.mt_buonme['3c'].win_without_win_rate.baylo;
      }
      return sum;
    },
    sum_win_without_win_rate_3c_xc(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['3c'].win_without_win_rate.dau;
        sum += this.report.summary.mn['3c'].win_without_win_rate.duoi;
        sum += this.report.summary.mb['3c'].win_without_win_rate.dau;
        sum += this.report.summary.mb['3c'].win_without_win_rate.duoi;
        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['3c'].win_without_win_rate.dau;
          sum += this.report.summary.mb_ngan['3c'].win_without_win_rate.duoi;
        }
        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['3c'].win_without_win_rate.dau;
          sum += this.report.summary.mb_hanoi['3c'].win_without_win_rate.duoi;
        }
        sum += this.report.summary.mt['3c'].win_without_win_rate.dau;
        sum += this.report.summary.mt['3c'].win_without_win_rate.duoi;

          sum += this.report.summary.mn_buonme['3c'].win_without_win_rate.dau;
          sum += this.report.summary.mn_buonme['3c'].win_without_win_rate.duoi;
          sum += this.report.summary.mn_buonme['3c'].win_without_win_rate.ke;
          sum += this.report.summary.mb_buonme['3c'].win_without_win_rate.dau;
          sum += this.report.summary.mb_buonme['3c'].win_without_win_rate.duoi;
          sum += this.report.summary.mb_buonme['3c'].win_without_win_rate.ke;
          sum += this.report.summary.mt_buonme['3c'].win_without_win_rate.dau;
          sum += this.report.summary.mt_buonme['3c'].win_without_win_rate.duoi;
          sum += this.report.summary.mt_buonme['3c'].win_without_win_rate.ke;
      }
      return sum;
    },
    sum_win_without_win_rate_4c(){
      let sum = 0;
      if(!this._.isEmpty(this.report.summary)){
        sum += this.report.summary.mn['4c'].win_without_win_rate.dat;
        sum += this.report.summary.mn['4c'].win_without_win_rate.dx;
        sum += this.report.summary.mn['4c'].win_without_win_rate.baolo;
        sum += this.report.summary.mn['4c'].win_without_win_rate.dau;
        sum += this.report.summary.mn['4c'].win_without_win_rate.duoi;
        sum += this.report.summary.mn['4c'].win_without_win_rate.baylo;

        sum += this.report.summary.mb['4c'].win_without_win_rate.dat;
        sum += this.report.summary.mb['4c'].win_without_win_rate.dx;
        sum += this.report.summary.mb['4c'].win_without_win_rate.baolo;
        sum += this.report.summary.mb['4c'].win_without_win_rate.dau;
        sum += this.report.summary.mb['4c'].win_without_win_rate.duoi;
        sum += this.report.summary.mb['4c'].win_without_win_rate.baylo;

        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum += this.report.summary.mb_ngan['4c'].win_without_win_rate.dat;
          sum += this.report.summary.mb_ngan['4c'].win_without_win_rate.dx;
          sum += this.report.summary.mb_ngan['4c'].win_without_win_rate.baolo;
          sum += this.report.summary.mb_ngan['4c'].win_without_win_rate.dau;
          sum += this.report.summary.mb_ngan['4c'].win_without_win_rate.duoi;
          sum += this.report.summary.mb_ngan['4c'].win_without_win_rate.baylo;
        }

        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum += this.report.summary.mb_hanoi['4c'].win_without_win_rate.dat;
          sum += this.report.summary.mb_hanoi['4c'].win_without_win_rate.dx;
          sum += this.report.summary.mb_hanoi['4c'].win_without_win_rate.baolo;
          sum += this.report.summary.mb_hanoi['4c'].win_without_win_rate.dau;
          sum += this.report.summary.mb_hanoi['4c'].win_without_win_rate.duoi;
          sum += this.report.summary.mb_hanoi['4c'].win_without_win_rate.baylo;
        }

        sum += this.report.summary.mt['4c'].win_without_win_rate.dat;
        sum += this.report.summary.mt['4c'].win_without_win_rate.dx;
        sum += this.report.summary.mt['4c'].win_without_win_rate.baolo;
        sum += this.report.summary.mt['4c'].win_without_win_rate.dau;
        sum += this.report.summary.mt['4c'].win_without_win_rate.duoi;
        sum += this.report.summary.mt['4c'].win_without_win_rate.baylo;

          sum += this.report.summary.mn_buonme['4c'].win_without_win_rate.dat;
          sum += this.report.summary.mn_buonme['4c'].win_without_win_rate.dx;
          sum += this.report.summary.mn_buonme['4c'].win_without_win_rate.baolo;
          sum += this.report.summary.mn_buonme['4c'].win_without_win_rate.dau;
          sum += this.report.summary.mn_buonme['4c'].win_without_win_rate.duoi;
          sum += this.report.summary.mn_buonme['4c'].win_without_win_rate.baylo;
          sum += this.report.summary.mb_buonme['4c'].win_without_win_rate.dat;
          sum += this.report.summary.mb_buonme['4c'].win_without_win_rate.dx;
          sum += this.report.summary.mb_buonme['4c'].win_without_win_rate.baolo;
          sum += this.report.summary.mb_buonme['4c'].win_without_win_rate.dau;
          sum += this.report.summary.mb_buonme['4c'].win_without_win_rate.duoi;
          sum += this.report.summary.mb_buonme['4c'].win_without_win_rate.baylo;
          sum += this.report.summary.mt_buonme['4c'].win_without_win_rate.dat;
          sum += this.report.summary.mt_buonme['4c'].win_without_win_rate.dx;
          sum += this.report.summary.mt_buonme['4c'].win_without_win_rate.baolo;
          sum += this.report.summary.mt_buonme['4c'].win_without_win_rate.dau;
          sum += this.report.summary.mt_buonme['4c'].win_without_win_rate.duoi;
          sum += this.report.summary.mt_buonme['4c'].win_without_win_rate.baylo;
      }
      return sum;
    },
    sum_total(){
      let sum = new Big(0);

      sum = sum.plus( this.sum_cost_1c );
      sum = sum.plus(this.sum_cost_giainhat);
      sum = sum.plus( this.sum_cost_2c_bao );
      sum = sum.plus( this.sum_cost_2c_baylo );
      sum = sum.plus( this.sum_cost_2c_tamlo );
      sum = sum.plus( this.sum_cost_2c_dd );
      sum = sum.plus( this.sum_cost_2c_dat );
      sum = sum.plus( this.sum_cost_2c_dax );
      sum = sum.plus( this.sum_cost_2c_dax2 );
      sum = sum.plus( this.sum_cost_2c_dax3 );
      sum = sum.plus( this.sum_cost_2c_dax4 );

      sum = sum.minus( this.sum_win_1c );
      sum = sum.minus(this.sum_win_giainhat);
      sum = sum.minus( this.sum_win_2c_bao );
      sum = sum.minus( this.sum_win_2c_baylo );
      sum = sum.minus( this.sum_win_2c_tamlo );
      sum = sum.minus( this.sum_win_2c_dd );
      sum = sum.minus( (this._.isNumber(this.sum_win_2c_ui)) ? this.sum_win_2c_ui : 0 );
      sum = sum.minus( this.sum_win_2c_dat );
      sum = sum.minus( this.sum_win_2c_dax );
      sum = sum.minus( this.sum_win_2c_dax2 );
      sum = sum.minus( this.sum_win_2c_dax3 );
      sum = sum.minus( this.sum_win_2c_dax4 );

      sum = sum.plus( this.sum_cost_3c_bao );
      sum = sum.plus( this.sum_cost_3c_bay );
      sum = sum.plus( this.sum_cost_3c_xc );
      sum = sum.plus( this.sum_cost_4c );

      sum = sum.minus( this.sum_win_3c_bao );
      sum = sum.minus( this.sum_win_3c_bay );
      sum = sum.minus( this.sum_win_3c_xc );
      sum = sum.minus( this.sum_win_4c );

      return (this.selected_customer.type === 1) ? sum.toNumber() : -sum.toNumber();
    },
    sum_result(){
      let sum = new Big(0);
      if(!this._.isEmpty(this.report.summary)){
        sum = sum.plus( this.report.summary.mn['2c'].result.dat );
        sum = sum.plus( this.report.summary.mn['2c'].result.dx );
        sum = sum.plus( this.report.summary.mn['2c'].result.dx_2 );
        sum = sum.plus( this.report.summary.mn['2c'].result.dx_3 );
        sum = sum.plus( this.report.summary.mn['2c'].result.dx_4 );
        sum = sum.plus( this.report.summary.mn['2c'].result.baolo );
        sum = sum.plus( this.report.summary.mn['2c'].result.dau );
        sum = sum.plus( this.report.summary.mn['2c'].result.duoi );
        sum = sum.plus( this.report.summary.mn['2c'].result.baylo );
        sum = sum.plus( this.report.summary.mn['2c'].result.tamlo );
        sum = sum.plus( (this._.isNumber(this.report.summary.mn['2c'].result.ui)) ? this.report.summary.mn['2c'].result.ui : 0 );
        sum = sum.plus( (this._.isNumber(this.report.summary.mt['2c'].result.ui)) ? this.report.summary.mt['2c'].result.ui : 0 );

        sum = sum.plus( this.report.summary.mn['3c'].result.dat );
        sum = sum.plus( this.report.summary.mn['3c'].result.dx );
        sum = sum.plus( this.report.summary.mn['3c'].result.baolo );
        sum = sum.plus( this.report.summary.mn['3c'].result.dau );
        sum = sum.plus( this.report.summary.mn['3c'].result.duoi );
        sum = sum.plus( this.report.summary.mn['3c'].result.baylo );

        sum = sum.plus( this.report.summary.mn['4c'].result.dat );
        sum = sum.plus( this.report.summary.mn['4c'].result.dx );
        sum = sum.plus( this.report.summary.mn['4c'].result.baolo );
        sum = sum.plus( this.report.summary.mn['4c'].result.dau );
        sum = sum.plus( this.report.summary.mn['4c'].result.duoi );
        sum = sum.plus( this.report.summary.mn['4c'].result.baylo );

        sum = sum.plus( this.report.summary.mb['2c'].result.dat );
        sum = sum.plus( this.report.summary.mb['2c'].result.dx );
        sum = sum.plus( this.report.summary.mb['2c'].result.dx_2 );
        sum = sum.plus( this.report.summary.mb['2c'].result.dx_3 );
        sum = sum.plus( this.report.summary.mb['2c'].result.dx_4 );
        sum = sum.plus( this.report.summary.mb['2c'].result.baolo );
        sum = sum.plus( this.report.summary.mb['2c'].result.dau );
        sum = sum.plus( this.report.summary.mb['2c'].result.duoi );
        sum = sum.plus( this.report.summary.mb['2c'].result.baylo );
        sum = sum.plus( this.report.summary.mb['2c'].result.tamlo );

        sum = sum.plus( this.report.summary.mb['3c'].result.dat );
        sum = sum.plus( this.report.summary.mb['3c'].result.dx );
        sum = sum.plus( this.report.summary.mb['3c'].result.baolo );
        sum = sum.plus( this.report.summary.mb['3c'].result.dau );
        sum = sum.plus( this.report.summary.mb['3c'].result.duoi );
        sum = sum.plus( this.report.summary.mb['3c'].result.baylo );

        sum = sum.plus( this.report.summary.mb['4c'].result.dat );
        sum = sum.plus( this.report.summary.mb['4c'].result.dx );
        sum = sum.plus( this.report.summary.mb['4c'].result.baolo );
        sum = sum.plus( this.report.summary.mb['4c'].result.dau );
        sum = sum.plus( this.report.summary.mb['4c'].result.duoi );
        sum = sum.plus( this.report.summary.mb['4c'].result.baylo );

        if(!this._.isUndefined(this.report.summary.mb_ngan)){
          sum = sum.plus( this.report.summary.mb_ngan['1c'].result.ngang );
          sum = sum.plus( this.report.summary.mb_ngan['2c'].result.dat );
          sum = sum.plus( this.report.summary.mb_ngan['2c'].result.dx );
          sum = sum.plus( this.report.summary.mb_ngan['2c'].result.dx_2 );
          sum = sum.plus( this.report.summary.mb_ngan['2c'].result.dx_3 );
          sum = sum.plus( this.report.summary.mb_ngan['2c'].result.dx_4 );
          sum = sum.plus( this.report.summary.mb_ngan['2c'].result.baolo );
          sum = sum.plus( this.report.summary.mb_ngan['2c'].result.dau );
          sum = sum.plus( this.report.summary.mb_ngan['2c'].result.duoi );
          sum = sum.plus( this.report.summary.mb_ngan['2c'].result.baylo );
          sum = sum.plus( this.report.summary.mb_ngan['2c'].result.tamlo );

          sum = sum.plus( this.report.summary.mb_ngan['3c'].result.dat );
          sum = sum.plus( this.report.summary.mb_ngan['3c'].result.dx );
          sum = sum.plus( this.report.summary.mb_ngan['3c'].result.baolo );
          sum = sum.plus( this.report.summary.mb_ngan['3c'].result.dau );
          sum = sum.plus( this.report.summary.mb_ngan['3c'].result.duoi );
          sum = sum.plus( this.report.summary.mb_ngan['3c'].result.baylo );

          sum = sum.plus( this.report.summary.mb_ngan['4c'].result.dat );
          sum = sum.plus( this.report.summary.mb_ngan['4c'].result.dx );
          sum = sum.plus( this.report.summary.mb_ngan['4c'].result.baolo );
          sum = sum.plus( this.report.summary.mb_ngan['4c'].result.dau );
          sum = sum.plus( this.report.summary.mb_ngan['4c'].result.duoi );
          sum = sum.plus( this.report.summary.mb_ngan['4c'].result.baylo );
        }

        if (!this._.isUndefined(this.report.summary.mb_hanoi)) {
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.giainhat);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.daunhat);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.dat);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.dx);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.dx_2);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.dx_3);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.dx_4);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.baolo);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.dau);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.duoi);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.baylo);
          sum = sum.plus(this.report.summary.mb_hanoi['2c'].result.tamlo);

          sum = sum.plus(this.report.summary.mb_hanoi['3c'].result.dat);
          sum = sum.plus(this.report.summary.mb_hanoi['3c'].result.dx);
          sum = sum.plus(this.report.summary.mb_hanoi['3c'].result.baolo);
          sum = sum.plus(this.report.summary.mb_hanoi['3c'].result.dau);
          sum = sum.plus(this.report.summary.mb_hanoi['3c'].result.duoi);
          sum = sum.plus(this.report.summary.mb_hanoi['3c'].result.baylo);

          sum = sum.plus(this.report.summary.mb_hanoi['4c'].result.dat);
          sum = sum.plus(this.report.summary.mb_hanoi['4c'].result.dx);
          sum = sum.plus(this.report.summary.mb_hanoi['4c'].result.baolo);
          sum = sum.plus(this.report.summary.mb_hanoi['4c'].result.dau);
          sum = sum.plus(this.report.summary.mb_hanoi['4c'].result.duoi);
          sum = sum.plus(this.report.summary.mb_hanoi['4c'].result.baylo);
        }

        sum = sum.plus( this.report.summary.mt['2c'].result.dat );
        sum = sum.plus( this.report.summary.mt['2c'].result.dx );
        sum = sum.plus( this.report.summary.mt['2c'].result.dx_2 );
        sum = sum.plus( this.report.summary.mt['2c'].result.dx_3 );
        sum = sum.plus( this.report.summary.mt['2c'].result.dx_4 );
        sum = sum.plus( this.report.summary.mt['2c'].result.baolo );
        sum = sum.plus( this.report.summary.mt['2c'].result.dau );
        sum = sum.plus( this.report.summary.mt['2c'].result.duoi );
        sum = sum.plus( this.report.summary.mt['2c'].result.baylo );
        sum = sum.plus( this.report.summary.mt['2c'].result.tamlo );

        sum = sum.plus( this.report.summary.mt['3c'].result.dat );
        sum = sum.plus( this.report.summary.mt['3c'].result.dx );
        sum = sum.plus( this.report.summary.mt['3c'].result.baolo );
        sum = sum.plus( this.report.summary.mt['3c'].result.dau );
        sum = sum.plus( this.report.summary.mt['3c'].result.duoi );
        sum = sum.plus( this.report.summary.mt['3c'].result.baylo );

        sum = sum.plus( this.report.summary.mt['4c'].result.dat );
        sum = sum.plus( this.report.summary.mt['4c'].result.dx );
        sum = sum.plus( this.report.summary.mt['4c'].result.baolo );
        sum = sum.plus( this.report.summary.mt['4c'].result.dau );
        sum = sum.plus( this.report.summary.mt['4c'].result.duoi );
        sum = sum.plus( this.report.summary.mt['4c'].result.baylo );

        //
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.dat );
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.dx );
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.dx_2 );
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.dx_3 );
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.dx_4 );
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.baolo );
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.dau );
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.duoi );
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.baylo );
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.tamlo );
          sum = sum.plus( this.report.summary.mn_buonme['2c'].result.ke );
          sum = sum.plus( (this._.isNumber(this.report.summary.mn_buonme['2c'].result.ui)) ? this.report.summary.mn_buonme['2c'].result.ui : 0 );

          sum = sum.plus( this.report.summary.mn_buonme['3c'].result.dat );
          sum = sum.plus( this.report.summary.mn_buonme['3c'].result.dx );
          sum = sum.plus( this.report.summary.mn_buonme['3c'].result.baolo );
          sum = sum.plus( this.report.summary.mn_buonme['3c'].result.dau );
          sum = sum.plus( this.report.summary.mn_buonme['3c'].result.duoi );
          sum = sum.plus( this.report.summary.mn_buonme['3c'].result.baylo );
          sum = sum.plus( this.report.summary.mn_buonme['3c'].result.ke );

          sum = sum.plus( this.report.summary.mn_buonme['4c'].result.dat );
          sum = sum.plus( this.report.summary.mn_buonme['4c'].result.dx );
          sum = sum.plus( this.report.summary.mn_buonme['4c'].result.baolo );
          sum = sum.plus( this.report.summary.mn_buonme['4c'].result.dau );
          sum = sum.plus( this.report.summary.mn_buonme['4c'].result.duoi );
          sum = sum.plus( this.report.summary.mn_buonme['4c'].result.baylo );

          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.dat );
          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.dx );
          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.dx_2 );
          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.dx_3 );
          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.dx_4 );
          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.baolo );
          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.dau );
          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.duoi );
          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.baylo );
          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.tamlo );
          sum = sum.plus( this.report.summary.mb_buonme['2c'].result.ke );

          sum = sum.plus( this.report.summary.mb_buonme['3c'].result.dat );
          sum = sum.plus( this.report.summary.mb_buonme['3c'].result.dx );
          sum = sum.plus( this.report.summary.mb_buonme['3c'].result.baolo );
          sum = sum.plus( this.report.summary.mb_buonme['3c'].result.dau );
          sum = sum.plus( this.report.summary.mb_buonme['3c'].result.duoi );
          sum = sum.plus( this.report.summary.mb_buonme['3c'].result.baylo );
          sum = sum.plus( this.report.summary.mb_buonme['3c'].result.ke );

          sum = sum.plus( this.report.summary.mb_buonme['4c'].result.dat );
          sum = sum.plus( this.report.summary.mb_buonme['4c'].result.dx );
          sum = sum.plus( this.report.summary.mb_buonme['4c'].result.baolo );
          sum = sum.plus( this.report.summary.mb_buonme['4c'].result.dau );
          sum = sum.plus( this.report.summary.mb_buonme['4c'].result.duoi );
          sum = sum.plus( this.report.summary.mb_buonme['4c'].result.baylo );

          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.dat );
          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.dx );
          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.dx_2 );
          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.dx_3 );
          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.dx_4 );
          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.baolo );
          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.dau );
          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.duoi );
          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.baylo );
          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.tamlo );
          sum = sum.plus( this.report.summary.mt_buonme['2c'].result.ke );

          sum = sum.plus( this.report.summary.mt_buonme['3c'].result.dat );
          sum = sum.plus( this.report.summary.mt_buonme['3c'].result.dx );
          sum = sum.plus( this.report.summary.mt_buonme['3c'].result.baolo );
          sum = sum.plus( this.report.summary.mt_buonme['3c'].result.dau );
          sum = sum.plus( this.report.summary.mt_buonme['3c'].result.duoi );
          sum = sum.plus( this.report.summary.mt_buonme['3c'].result.baylo );
          sum = sum.plus( this.report.summary.mt_buonme['3c'].result.ke );

          sum = sum.plus( this.report.summary.mt_buonme['4c'].result.dat );
          sum = sum.plus( this.report.summary.mt_buonme['4c'].result.dx );
          sum = sum.plus( this.report.summary.mt_buonme['4c'].result.baolo );
          sum = sum.plus( this.report.summary.mt_buonme['4c'].result.dau );
          sum = sum.plus( this.report.summary.mt_buonme['4c'].result.duoi );
          sum = sum.plus( this.report.summary.mt_buonme['4c'].result.baylo );
      }
      return sum.toNumber();
    },
    sum_final(){
      if(this.line_percent > 0){
        return this.sum_result - (this.sum_result * this.line_percent / 100);
      }
      return Math.round(this.sum_result);
    },
    total_percent(){
      if(this.playStyle === 'mb_ngan') {
        return this._.isUndefined(this.selected_customer.config_deal) ? '' : this.selected_customer.config_deal.mb_ngan.total_percent;
      }
      else if(this.playStyle === 'mb_buonme') {
          return this._.isUndefined(this.selected_customer.config_deal) ? '' : this.selected_customer.config_deal.mb_buonme.total_percent;
      }
      else if (this.playStyle === 'mb_hanoi') {
        return this._.isUndefined(this.selected_customer.config_deal) ? '' : this.selected_customer.config_deal.mb_hanoi.total_percent;
      }
      else if (this.playStyle === 'mn_buonme') {
          return this._.isUndefined(this.selected_customer.config_deal) ? '' : this.selected_customer.config_deal.mn_buonme.total_percent;
      }
      else if (this.playStyle === 'mt_buonme') {
          return this._.isUndefined(this.selected_customer.config_deal) ? '' : this.selected_customer.config_deal.mt_buonme.total_percent;
      }
      return this._.isUndefined(this.selected_customer.config_deal) ? '' : this.selected_customer.config_deal[this.region].total_percent;
    },
    line_percent(){
      if(this._.isUndefined(this.selected_customer.config_deal)){
        return 0;
      }

      if(this.playStyle === 'mb_ngan'){
        if(this.selected_customer.type === 2 && this.sum_result < 0){
          return this.selected_customer.config_deal.mb_ngan.line_percent;
        }else if(this.selected_customer.type === 1 && this.sum_result > 0){
          return this.selected_customer.config_deal.mb_ngan.line_percent;
        }
      }else if (this.playStyle.indexOf('_buonme') >= 0) {
        let target_region = this.region + '_buonme';
        if (this.selected_customer.type === 2 && this.sum_result < 0) {
          return this.selected_customer.config_deal[target_region].line_percent;
        }
        else if (this.selected_customer.type === 1 && this.sum_result > 0) {
          return this.selected_customer.config_deal[target_region].line_percent;
        }
      }
      else if (this.playStyle.indexOf('_hanoi') >= 0) {
        if (this.selected_customer.type === 2 && this.sum_result < 0) {
          return this.selected_customer.config_deal.mb_hanoi.line_percent;
        }
        else if (this.selected_customer.type === 1 && this.sum_result > 0) {
          return this.selected_customer.config_deal.mb_hanoi.line_percent;
        }
      }
      else {
        if(this.selected_customer.type === 2 && this.sum_result < 0){
          return this.selected_customer.config_deal[this.region].line_percent;
        }else if(this.selected_customer.type === 1 && this.sum_result > 0){
          return this.selected_customer.config_deal[this.region].line_percent;
        }
      }

      return 0;
    },
    save_report_image(){
      let result_str_color = this.sum_total >= 0 ? 'green' : 'red';
      let result_str = this.sum_total >= 0 ? 'Thu: ' : 'Bù: ';
      result_str += numeral(this.sum_total).format('0,0[.]0') + ' x ' + numeral(this.total_percent).format('0,0[.]0') + '%';
      result_str += ' = ' + numeral(this.sum_result).format('0,0[.]0');

      if(this.line_percent > 0){
        result_str += ' - (' + numeral(this.line_percent).format('0,0[.]0') + '% hồi) = ' + numeral(this.sum_final).format('0,0[.]0');
      }

      let region_str = encodeURIComponent(' (' + this.title_play_style(this.region, '') + ')');
      let link = process.env.VUE_APP_API_URL + `misc/generate-summary-img?drawdate=${this.$moment(this.selected_drawdate).format('DD/MM/YYYY')}${region_str}&customer_name=${this.selected_customer.fullname}&result_str=${result_str}&result_str_color=${result_str_color}&`;

      if(this.sum_point_1c > 0){
        link += 'row[]='+ this.command_play_style('1C', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_1c).format('0,0[.]0') + '|' + numeral(this.sum_cost_1c).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_1c).format('0,0[.]0')+'&';
      }
      if(this.sum_point_2c_bao > 0){
        link += 'row[]=' + this.command_play_style('2CB', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_2c_bao).format('0,0[.]0') + '|' + numeral(this.sum_cost_2c_bao).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_2c_bao).format('0,0[.]0') + '&';
      }
      if(this.sum_point_2c_dd > 0){
        link += 'row[]=' + this.command_play_style('2CĐ', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_2c_dd).format('0,0[.]0') + '|' + numeral(this.sum_cost_2c_dd).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_2c_dd).format('0,0[.]0') + '&';
      }
      if(this.sum_win_without_win_rate_2c_ui > 0){
        link += 'row[]=' + 'An ủi|||' + numeral(this.sum_win_without_win_rate_2c_ui).format('0,0[.]0') + '&';
      }
      if(this.sum_point_2c_baylo > 0){
        link += 'row[]=' + this.command_play_style('2CB7', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_2c_baylo).format('0,0[.]0') + '|' + numeral(this.sum_cost_2c_baylo).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_2c_baylo).format('0,0[.]0') + '&';
      }
      if(this.sum_point_2c_tamlo > 0){
        link += 'row[]=' + this.command_play_style('2CB8', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_2c_tamlo).format('0,0[.]0') + '|' + numeral(this.sum_cost_2c_tamlo).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_2c_tamlo).format('0,0[.]0') + '&';
      }
      if(this.sum_point_2c_dat > 0){
        link += 'row[]=' + this.command_play_style('ĐáT', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_2c_dat).format('0,0[.]0') + '|' + numeral(this.sum_cost_2c_dat).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_2c_dat).format('0,0[.]0') + '&';
      }
      if(this.sum_point_2c_dax > 0){
        link += 'row[]=' + this.command_play_style('ĐáX', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_2c_dax).format('0,0[.]0') + '|' + numeral(this.sum_cost_2c_dax).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_2c_dax).format('0,0[.]0') + '&';
      }
      if(this.sum_point_2c_dax2 > 0){
        link += 'row[]=' + this.command_play_style('ĐáX2', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_2c_dax2).format('0,0[.]0') + '|' + numeral(this.sum_cost_2c_dax2).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_2c_dax2).format('0,0[.]0') + '&';
      }
      if(this.sum_point_2c_dax3 > 0){
        link += 'row[]=' + this.command_play_style('ĐáX3', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_2c_dax3).format('0,0[.]0') + '|' + numeral(this.sum_cost_2c_dax3).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_2c_dax3).format('0,0[.]0') + '&';
      }
      if(this.sum_point_2c_dax4 > 0){
        link += 'row[]=' + this.command_play_style('ĐáX4', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_2c_dax4).format('0,0[.]0') + '|' + numeral(this.sum_cost_2c_dax4).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_2c_dax4).format('0,0[.]0') + '&';
      }
      if(this.sum_point_3c_bao > 0){
        link += 'row[]=' + this.command_play_style('3CB', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_3c_bao).format('0,0[.]0') + '|' + numeral(this.sum_cost_3c_bao).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_3c_bao).format('0,0[.]0') + '&';
      }
      if(this.sum_point_3c_bay > 0){
        link += 'row[]=' + this.command_play_style('3CB7', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_3c_bay).format('0,0[.]0') + '|' + numeral(this.sum_cost_3c_bay).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_3c_bay).format('0,0[.]0') + '&';
      }
      if(this.sum_point_3c_xc > 0){
        link += 'row[]=' + this.command_play_style('3CXC', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_3c_xc).format('0,0[.]0') + '|' + numeral(this.sum_cost_3c_xc).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_3c_xc).format('0,0[.]0') + '&';
      }
      if(this.sum_point_4c > 0){
        link += 'row[]=' + this.command_play_style('4C', this.playStyle) + '|' + numeral(this.sum_cost_without_rate_4c).format('0,0[.]0') + '|' + numeral(this.sum_cost_4c).format('0,0[.]0') + '|' + numeral(this.sum_win_without_win_rate_4c).format('0,0[.]0') + '&';
      }

      link += 'sum_row[]=TC|' + numeral(this.sum_cost_without_rate).format('0,0[.]0') + '|' + numeral(this.sum_cost).format('0,0[.]0') + '|' + numeral(this.sum_win).format('0,0[.]0') + '&';

      if(navigator.userAgent.indexOf('KOS') >= 0 || navigator.userAgent.indexOf('KTS') >= 0 || navigator.userAgent === ''){
        return 'savethisimage://?url=' + link;
      }

      return link;
    }
  },
  methods :{
    all_cn(type){
      let arr = [];
      this._.each(this.filter_channel_options[this.region], (item) => {
        arr.push(item[type]);
      });
      return arr;
    },
    updatedConfig(){
      this.$f7.dialog.alert('Đã lưu thay đổi!', 'SUCCESS');
      this.getAllReport();
    },
    getAllReport(){
      // this.$f7.preloader.show();
      let step_ok = 0;

      this.$store.dispatch('getReport', {
        from_drawdate:this.$moment(this.selected_drawdate).format('YYYY-MM-DD'),
        to_drawdate  :this.$moment(this.selected_drawdate).format('YYYY-MM-DD'),
        customer_id  :this.custId,
        region       :this.region,
        play_style   :this.playStyle
      }).then((data) => {
        // this.$f7.preloader.hide();
        this.report = data;
        this.checked_items = [];
        this.msg_selecting = false;
        step_ok = 1;
        return this.$store.dispatch('getOverPointReport', {
          region    :this.region,
          drawdate  :this.$moment(this.selected_drawdate).format('YYYY-MM-DD'),
          types     :this.filters.command,
          channels  :this.filters.channel === 'mb' ? 'mb' : this.filters.channel,
          customer  :this.custId,
          play_style:this.playStyle
        })
      }).then((data) => {
        this.report_data = data;
        step_ok = 2;
        this._.each(this.report_data.over_points, (msg) => {
          if(this.commands.indexOf(msg.command) < 0){
            this.commands.push(msg.command);
          }
        });

        return this.$store.dispatch('getOverPointWarningMessages', {
          drawdate  :this.$moment(this.selected_drawdate).format('YYYY-MM-DD'),
          region    :this.region,
          play_style:this.playStyle,
          customer  :this.custId
        })
      }).then((data) => {
        step_ok = 3;
        this.warning_messages = data.list_messages;
      }).catch(() => {
        // this.$f7.preloader.hide();

        if(step_ok === 0){
          this.report = {};
          this.report_data = {};
          this.warning_messages = {};
        }else if(step_ok === 1){
          this.report_data = {};
          this.warning_messages = {};
        }else if(step_ok === 2){
          this.warning_messages = {};
        }
      });
    },
    getReport(){
      // this.$f7.dialog.preloader();

      this.$store.dispatch('getReport', {
        from_drawdate:this.$moment(this.selected_drawdate).format('YYYY-MM-DD'),
        to_drawdate  :this.$moment(this.selected_drawdate).format('YYYY-MM-DD'),
        customer_id  :this.custId,
        region       :this.region,
        play_style   :this.playStyle
      }).then((data) => {
        // this.$f7.dialog.close();
        this.report = data;
      }).catch(() => {
        // this.$f7.dialog.close();
        this.report = {};
      });
    },
    getOverPointReport(){
      // this.$f7.dialog.preloader();

      this.$store.dispatch('getOverPointReport', {
        region    :this.region,
        drawdate  :this.$moment(this.selected_drawdate).format('YYYY-MM-DD'),
        types     :this.filters.command,
        channels  :this.filters.channel === 'mb' ? 'mb' : this.filters.channel,
        customer  :this.custId,
        play_style:this.playStyle
      }).then((data) => {
        // this.$f7.dialog.close();
        this.report_data = data;

        this._.each(this.report_data.over_points, (msg) => {
          if(this.commands.indexOf(msg.command) < 0){
            this.commands.push(msg.command);
          }
        });
      }).catch(() => {
        // this.$f7.dialog.close();
        this.report_data = {};
      });
    },
    getOverPointWarningMessages(){
      // this.$f7.dialog.preloader();

      this.$store.dispatch('getOverPointWarningMessages', {
        drawdate  :this.$moment(this.selected_drawdate).format('YYYY-MM-DD'),
        region    :this.region,
        customer  :this.custId,
        play_style:this.playStyle
      }).then((data) => {
        // this.$f7.dialog.close();
        this.warning_messages = data.list_messages;
      }).catch(() => {
        // this.$f7.dialog.close();
        this.warning_messages = {};
      });
    },
    chooseReportDate(){
      this.myCalendar.open();
    },
    goToCreate(message = ''){
      this.$f7router.navigate(`/xu-ly/${this.region}/${this.playStyle}/khach-hang/${this.custId}/them-tin-nhan`, {
        props:{
          drawDate:this.$moment(this.selected_drawdate).format('YYYY-MM-DD'),
          message :message
        }
      });
    },
    toggleCheckbox(id){
      let idx_checked = this.checked_items.indexOf(id);
      if(idx_checked >= 0){
        this.checked_items.splice(idx_checked, 1);
      }else{
        this.checked_items.push(id);
      }
    },
    toggleAllCheckbox(){
      if(this.checked_items.length > 0){
        this.checked_items = [];
      }else{
        this.checked_items = this.report.list_messages.map(function(item){
          return item.id;
        });
      }
    },
    sortReport(){
      this.commands = this._.shuffle(this.commands);
    },
    copyToClipboard(){
      let content = '';
      this._.each(this.report.list_messages, (item) => {
        if(this.checked_items.indexOf(item.id) >= 0){
          content += item.content_original + "\n";
        }
      });
      this.$copyText(content.trimRight());
      this.showToastBottom('Đã copied');
      // this.$f7.dialog.alert('', 'ĐÃ COPIED!');
    },
    copyReport(){
      let content = 'KIỐTSỐ - ' + this.$moment(this.selected_drawdate).format('DD/MM/YYYY') + "\n";

      content += this.title_play_style(this.region, this.playStyle) + ' | ';
      content += this.selected_customer.type === 2 ? 'Chủ: ' : 'Khách: ';
      content += this.selected_customer.fullname + "\n--------------------\n";

      if(this.sum_point_1c > 0){
        content += this.command_play_style('1C', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_1c).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_1c).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_2c_bao > 0){
        content += this.command_play_style('2CB', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_2c_bao).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_2c_bao).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_2c_dd > 0){
        content += this.command_play_style('2CĐ', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_2c_dd).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_2c_dd).format('0,0[.]0') + "\n";
      }
      if(this.sum_win_without_win_rate_2c_ui > 0){
        content += this.command_play_style('An Ủi', this.playStyle) + ' ';
        content += 'trúng: ';
        content += numeral(this.sum_win_without_win_rate_2c_ui).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_2c_baylo > 0){
        content += this.command_play_style('2CB7', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_2c_baylo).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_2c_baylo).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_2c_tamlo > 0){
        content += this.command_play_style('2CB8', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_2c_tamlo).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_2c_tamlo).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_2c_dat > 0){
        content += this.command_play_style('ĐáT', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_2c_dat).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_2c_dat).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_2c_dax > 0){
        content += this.command_play_style('ĐáX', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_2c_dax).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_2c_dax).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_2c_dax2 > 0){
        content += this.command_play_style('ĐáX2', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_2c_dax2).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_2c_dax2).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_2c_dax3 > 0){
        content += this.command_play_style('ĐáX3', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_2c_dax3).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_2c_dax3).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_2c_dax4 > 0){
        content += this.command_play_style('ĐáX4', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_2c_dax4).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_2c_dax4).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_3c_bao > 0){
        content += this.command_play_style('3CB', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_3c_bao).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_3c_bao).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_3c_bay > 0){
        content += this.command_play_style('3CB7', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_3c_bay).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_3c_bay).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_3c_xc > 0){
        content += this.command_play_style('3CXC', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_3c_xc).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_3c_xc).format('0,0[.]0') + "\n";
      }
      if(this.sum_point_4c > 0){
        content += this.command_play_style('4C', this.playStyle) + ': ';
        content += numeral(this.sum_cost_without_rate_4c).format('0,0[.]0') + ' | ';
        content += 'Trúng: ';
        content += numeral(this.sum_win_without_win_rate_4c).format('0,0[.]0') + "\n";
      }

      content += "--------------------\nTC: ";
      content += numeral(this.sum_cost_without_rate).format('0,0[.]0') + ' | ';
      content += 'TC: ';
      content += numeral(this.sum_win).format('0,0[.]0') + "\n";

      content += 'TC ';
      content += this.sum_total >= 0 ? 'Thu ' : 'Bù ';

      if(this.line_percent > 0){
        if(this.total_percent !== 100){
          content += numeral(this.total_percent).format('0,0[.]0') + '% ';
        }
        content += ': ' + numeral(this.sum_final).format('0,0[.]0') + ' (-' + numeral(this.line_percent).format('0,0[.]0') + '% hồi)';
      } else {
        if(this.total_percent !== 100){
          content += numeral(this.total_percent).format('0,0[.]0') + '% ';
        }
        content += ': ' + numeral(this.sum_result).format('0,0[.]0');
      }

      this.$copyText(content.trimRight());
      this.showToastBottom('Đã copied');
    },
    showToastBottom(text){
      const self = this;
      if(!self.toastBottom){
        self.toastBottom = self.$f7.toast.create({
          text        :text,
          closeTimeout:2000,
        });
      }
      self.toastBottom.open();
    },
    removeSelectedMessage(){
      if(this.checked_items.length === 0){
        this.$f7.dialog.alert('', 'Vui lòng chọn tin nhắn muốn xóa và thử lại!');
        return false;
      }

      this.$f7.preloader.show();

      this.$store.dispatch('removeMessages', {ids:this.checked_items})
          .then(() => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert('', 'ĐÃ XÓA!');
            this.checked_items = [];
            this.getAllReport();
          })
          .catch((error) => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert(error, 'LỖI!');
          });
    },
    changeAllConfig(type, name, value){
      let real_region = this.region;
      if(this.playStyle === 'mb_ngan'){
        real_region = 'mb_ngan';
      }

      if(type === '2c'){
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
          });
        });
      }else if(type === '3c'){
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[real_region][datename][cn]['3c'][name] = value;
          });
        });
      }else if(type === '4c'){
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[real_region][datename][cn]['4c'][name] = value;
          });
        });
      }else if(type === 'da'){
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
          });
        });
      }else if(type === 'dx'){
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
          });
        });
      }
    },
    changeDetailConfig(channel_type, type, name, value){
      let real_region = this.region;
      if(this.playStyle === 'mb_ngan'){
        real_region = 'mb_ngan';
      }

      if(type === '2c' && channel_type.indexOf('_') < 0){
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if(this.filter_channel_options[real_region][datename][channel_type] === cn){
              this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
            }
          });
        });
      }else if(type === '3c'){
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if(this.filter_channel_options[real_region][datename][channel_type] === cn){
              this.over_point_config.general_overpoint[real_region][datename][cn]['3c'][name] = value;
            }
          });
        });
      }else if(type === '4c'){
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if(this.filter_channel_options[real_region][datename][channel_type] === cn){
              this.over_point_config.general_overpoint[real_region][datename][cn]['4c'][name] = value;
            }
          });
        });
      }else if(type === 'da'){
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if(this.filter_channel_options[real_region][datename][channel_type] === cn){
              this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
            }
          });
        });
      }else if(type === 'dx'){
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if(this.filter_channel_options[real_region][datename][channel_type] === cn){
              this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
            }
          });
        });
      }else if(type === '2c' && channel_type.indexOf('_') >= 0){
        let type_cns = channel_type.split('_');
        this._.each(this.over_point_config.general_overpoint[real_region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[real_region][datename], (v3, cn) => {
            if(cn.indexOf('_') >= 0){
              let cn1 = this.filter_channel_options[real_region][datename][type_cns[0]];
              let cn2 = this.filter_channel_options[real_region][datename][type_cns[1]];

              let cns = cn.split('_');
              if(cn1 === cns[0] && cn2 === cns[1]){
                this.over_point_config.general_overpoint[real_region][datename][cn]['2c'][name] = value;
              }
            }
          });
        });
      }
    },
    chooseFilter(name, value){
      this.filters[name] = value;
      this.getOverPointReport();
    },
    goToEditMessage(message){
      message.id = message.message_id;

      this.$f7router.navigate(`/xu-ly/${this.region}/${this.playStyle}/khach-hang/${this.custId}/sua-tin-nhan/${message.message_id}`, {
        props:{
          drawDate:this.$moment(this.selected_drawdate).format('YYYY-MM-DD'),
          message :message
        }
      });
    },
    changeCustomer(cust_id){
      this.$store.state.selected_customer = this._.find(this.customers, {id:parseInt(cust_id)});
      this.$f7router.navigate(`/xu-ly/${this.region}/${this.playStyle}/khach-hang/${this.selected_customer.id}`);
    },
    openPopupFriend(){
      this.popup_friends = true;
      this.getFriends();
      this.getChatbots();
    },
    getFriends(){
      if(this.friends.length === 0){
        this.$store.dispatch('getFriendList')
            .catch((error) => {
              this.$f7.dialog.alert(error, 'LỖI!');
            });
      }
    },
    getChatMessages(){
      const self = this;
      this.$store.dispatch('getChatMessages', {
        chatroom_key:this.selected_friend.chatroom_key,
        limit       :100
      })
          .then((data) => {
            this.messagesData = this._.reverse(data);
            setTimeout(() => {
              self.$refs.messages.scroll(200, 9999);
            }, 200);
          })
          .catch((error) => {
            this.$f7.dialog.alert(error, 'LỖI!');
          })
    },
    chooseFriend(friend){
      this.selected_friend = friend;
      this.messagesData = [];
      this.popup_friends = false;
      this.popup_chat = true;

      this.getChatMessages();
    },
    getChatbots() {
      let self = this;
      if(self.bots.length === 0){
        self.$store.dispatch('getChatBotRooms')
            .then((res) => {
              self.bots = res.data.data;
            })
            .catch((error) => {
              self.$f7.dialog.alert(error, 'LỖI!');
            });
      }
    },
    subTitle(item) {
      if (item.bot_type === 'telegram_free_text') {
        return `Tổng tin : ${item.stat_messages.total}`;
      }

      return `Tổng tin : ${item.stat_messages.total} | Xử lý : ${item.stat_messages.converted} | Hủy : ${item.stat_messages.denied}`;
    },
    getChatboxMessages() {
      const self = this;
      self.$store.dispatch('getChatRoomTempMessages', {
        room_id: self.selected_chatbot.id,
        draw_date: moment().format('YYYY-MM-DD')
      }).then((res) => {
        self.messagesData = self._.reverse(res.data.data);
        setTimeout(() => {
          self.$refs.messages.scroll(200, 9999);
        }, 200);
      }).catch((err) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    chooseChatbot(chatbot) {
      this.selected_chatbot = chatbot;
      this.messagesData = [];
      this.popup_friends = false;
      this.popup_chat = true;

      this.getChatboxMessages();
    },
    isFirstMessage(message, index){
      const self = this;
      const previousMessage = self.messagesFormatted[index - 1];
      if(message.isTitle) return false;
      if(!previousMessage || previousMessage.type !== message.type || previousMessage.name !== message.name) return true;
      return false;
    },
    isLastMessage(){
      return true;
    },
    isTailMessage(message, index){
      const self = this;
      const nextMessage = self.messagesFormatted[index + 1];
      if(message.isTitle) return false;
      if(!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
      return false;
    },
    chooseMessage(message){
      let idx_checked = this._.findIndex(this.selected_messages, {id:message.id});
      if(idx_checked >= 0){
        this.selected_messages.splice(idx_checked, 1);
      }else{
        this.selected_messages.push(message);
      }
    },
    submitChooseMessage(){
      if(this.selected_messages.length === 0){
        this.$f7.dialog.alert('Vui lòng chọn ít nhất 1 tin nhắn!', 'THÔNG BÁO');
        return false;
      }

      this.popup_chat = false;
      let content = '';
      this._.each(this.selected_messages, (message, idx) => {
        if(idx > 0){
          content += '@ ';
        }
        content += message.text + "\n";
      });
      this.goToCreate(content.trim());
    },
    is_in_app() {
      if (navigator.userAgent.indexOf('KOS') >= 0 || navigator.userAgent.indexOf('KTS') >= 0 || navigator.userAgent === '') {
        return true;
      }

      return false;
    }
  },
  watch   :{
    selected_drawdate(){
      this.getAllReport();
      this.$refs.configOverPoint.getBlockNumbers();
    }
  },
  mounted(){
    const self = this;
    const app = self.$f7;

    this.myCalendar = app.calendar.create({
      locale       :'vi-VN',
      openIn       :'customModal',
      dateFormat   :'DD/MM/YYYY',
      closeOnSelect:true,
      on           :{
        close(c){
          self.$store.state.selected_drawdate = self.$moment(c.value[0]);
        }
      }
    });
  }
};
</script>
<style scoped>
.position-right {
  position : absolute;
  right    : 5px;
}
.fab-right-bottom.button-2 {
  bottom : calc((var(--f7-fab-margin) * 5) + var(--f7-safe-area-bottom));
}
.btn-copy {
  display : inline-block;
  width   : 60px;
}
.abs-top-right {
  position : absolute;
  top      : 8px;
  right    : 5px;
}
.pb-icon{
  padding-bottom: 120px
}
.fixed-top{
  position: fixed;
  top: calc(var(--f7-navbar-height) + var(--f7-subnavbar-height) + 5px);
  height: var(--f7-customer-detail-top);
  width: 100%;
  left: 0;
  /*background: #EFEFF4;*/
  z-index: 109;
}
.after-fixed-top{
  padding-top: calc(var(--f7-customer-detail-top) + 5px);
}
.tabs .tab-active{
  min-height: 400px;
}
.data-table.bordered tfoot th:not(:last-child){
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
